// French translations - Complete
export default {
  // Navigation
  nav: {
    home: 'Accueil',
    dashboard: 'Tableau de bord',
    login: 'Connexion',
    register: 'Inscription',
    logout: 'Déconnexion',
    settings: 'Paramètres',
    admin: 'Administration',
    menu: 'Menu',
    createQuiz: 'Créer un Quiz',
    createQuestionnaire: 'Créer Questionnaire',
    createEvent: 'Créer Événement',
    quizMusic: 'Musiques Quiz',
    users: 'Utilisateurs',
    backToDashboard: 'Retour au tableau de bord'
  },
  
  // Common
  common: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    create: 'Créer',
    add: 'Ajouter',
    search: 'Rechercher',
    filter: 'Filtrer',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    confirm: 'Confirmer',
    confirmDelete: 'Confirmer la suppression',
    confirmDeleteMessage: 'Êtes-vous sûr de vouloir supprimer',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    close: 'Fermer',
    yes: 'Oui',
    no: 'Non',
    true: 'Vrai',
    false: 'Faux',
    all: 'Tout',
    none: 'Aucun',
    download: 'Télécharger',
    share: 'Partager',
    copy: 'Copier',
    copied: 'Copié !',
    play: 'Jouer',
    view: 'Voir',
    actions: 'Actions',
    logoutSuccess: 'Déconnexion réussie',
    or: 'ou',
    and: 'et',
    welcome: 'Bienvenue',
    required: 'Requis',
    optional: 'Optionnel',
    important: 'Important',
    submit: 'Soumettre',
    reset: 'Réinitialiser',
    start: 'Commencer',
    stop: 'Arrêter',
    pause: 'Pause',
    resume: 'Reprendre',
    finish: 'Terminer',
    continue: 'Continuer',
    skip: 'Passer',
    retry: 'Réessayer',
    refresh: 'Actualiser',
    more: 'Plus',
    less: 'Moins',
    show: 'Afficher',
    hide: 'Masquer',
    enable: 'Activer',
    disable: 'Désactiver',
    select: 'Sélectionner',
    selected: 'Sélectionné',
    upload: 'Uploader',
    uploading: 'Upload en cours...',
    preview: 'Aperçu',
    export: 'Exporter',
    import: 'Importer',
    print: 'Imprimer',
    send: 'Envoyer',
    sending: 'Envoi en cours...',
    sent: 'Envoyé',
    receive: 'Recevoir',
    noResults: 'Aucun résultat',
    loadMore: 'Charger plus',
    seeAll: 'Voir tout',
    duplicate: 'Dupliquer',
    saving: 'Enregistrement...',
    saveChanges: 'Enregistrer les modifications',
    copy: 'copie',
    showMore: 'Voir plus',
    showLess: 'Voir moins',
    from: 'De',
    to: 'À',
    date: 'Date',
    time: 'Heure',
    name: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    address: 'Adresse',
    description: 'Description',
    title: 'Titre',
    status: 'Statut',
    type: 'Type',
    category: 'Catégorie',
    tags: 'Tags',
    notes: 'Notes',
    comments: 'Commentaires',
    details: 'Détails',
    information: 'Informations',
    total: 'Total',
    quantity: 'Quantité',
    price: 'Prix',
    free: 'Gratuit',
    new: 'Nouveau',
    updated: 'Mis à jour',
    created: 'Créé',
    deleted: 'Supprimé',
    active: 'Actif',
    inactive: 'Inactif',
    pending: 'En attente',
    approved: 'Approuvé',
    rejected: 'Rejeté',
    public: 'Public',
    private: 'Privé',
    draft: 'Brouillon',
    published: 'Publié',
    admin: 'Admin',
    user: 'Utilisateur',
    madeWith: 'Fait avec',
    backToHome: 'Retour à l\'accueil',
    checking: 'Vérification...',
    verification: 'Vérification',
    access: 'Accès'
  },

  // System messages (toasts, alerts, confirmations)
  messages: {
    // Success messages
    success: {
      saved: 'Enregistré avec succès',
      deleted: 'Supprimé avec succès',
      updated: 'Mis à jour avec succès',
      created: 'Créé avec succès',
      copied: 'Copié !',
      linkCopied: 'Lien copié !',
      emailSent: 'Email envoyé !',
      emailVerified: 'Email vérifié ! Redirection...',
      emailAlreadyVerified: 'Votre email est déjà vérifié !',
      verificationEmailSent: '📧 Email de vérification renvoyé ! Vérifiez aussi vos spams.',
      tableCreated: 'Table créée avec succès',
      tableUpdated: 'Table modifiée avec succès',
      tableDeleted: 'Table supprimée',
      tableAdded: 'Table ajoutée',
      guestAssigned: 'Invité assigné',
      guestRemoved: 'Invité retiré de la table',
      planSaved: 'Plan sauvegardé',
      questionDuplicated: 'Question dupliquée',
      questionnaireUpdated: 'Questionnaire mis à jour !',
      quizUpdated: 'Quiz mis à jour !',
      responseDeleted: 'Réponse supprimée',
      musicDeleted: 'Musique supprimée',
      accountCreatedResend: 'Compte créé ! Cliquez sur "Renvoyer l\'email" pour recevoir le lien de vérification.'
    },
    // Error messages
    error: {
      generic: 'Une erreur est survenue',
      loading: 'Erreur lors du chargement',
      saving: 'Erreur lors de la sauvegarde',
      deleting: 'Erreur lors de la suppression',
      creating: 'Erreur lors de la création',
      updating: 'Erreur lors de la mise à jour',
      unauthorized: 'Accès non autorisé',
      notFound: 'Élément introuvable',
      quizNotFound: 'Quiz introuvable',
      questionnaireNotFound: 'Questionnaire introuvable',
      eventNotFound: 'Événement non trouvé',
      sessionNotFound: 'Session introuvable',
      sessionStarted: 'Cette session a déjà commencé',
      accessDenied: 'Vous n\'êtes pas autorisé à accéder à cette page',
      adminOnly: 'Accès réservé aux administrateurs',
      logoutError: 'Erreur lors de la déconnexion',
      tooManyAttempts: 'Trop de tentatives. Réessayez dans quelques minutes.',
      sessionExpired: 'Session expirée. Veuillez vous reconnecter.',
      emailNotVerified: 'Email pas encore vérifié. Vérifiez votre boîte mail et vos spams.',
      emailVerifiedNotValidated: 'Email vérifié mais compte non validé. Contactez l\'administrateur.',
      qrCodeNotRecognized: 'QR code non reconnu',
      qrCodeWrongEvent: 'Ce billet n\'appartient pas à cet événement',
      qrCodeReadError: 'Erreur lors de la lecture du QR code',
      playbackError: 'Erreur de lecture',
      assignmentError: 'Erreur lors de l\'assignation'
    },
    // Validation messages
    validation: {
      required: 'Ce champ est requis',
      titleRequired: 'Le titre est requis',
      nameRequired: 'Nom de table requis',
      tableNameRequired: 'Veuillez entrer un nom pour la table',
      sessionCodeRequired: 'Veuillez entrer un code de session',
      minQuestions: 'Ajoutez au moins une question',
      minOneQuestion: 'Minimum 1 question requise',
      questionTextRequired: 'Toutes les questions doivent avoir un texte',
      minOptions: 'Minimum 2 options requises',
      passwordMinLength: 'Le mot de passe doit contenir au moins 8 caractères',
      passwordLowercase: 'Le mot de passe doit contenir au moins une minuscule',
      passwordUppercase: 'Le mot de passe doit contenir au moins une majuscule',
      passwordSpecialChar: 'Le mot de passe doit contenir au moins un caractère spécial (ex: #, @, !)'
    },
    // Confirmation messages
    confirm: {
      delete: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
      logout: 'Êtes-vous sûr de vouloir vous déconnecter ?'
    }
  },

  // Pending validation page
  pendingValidation: {
    title: 'Vérifiez votre email',
    emailSentTo: 'Un email de vérification a été envoyé à',
    checkInbox: '📧 Cliquez sur le lien dans l\'email pour vérifier votre adresse. Vérifiez également vos spams.',
    accessGranted: '✅ Une fois votre email vérifié, vous aurez immédiatement accès à votre compte !',
    iVerified: 'J\'ai vérifié mon email',
    resendEmail: 'Renvoyer l\'email de vérification',
    logout: 'Se déconnecter'
  },
  
  // Home page
  home: {
    title: 'Bienvenue sur HugoQuiz',
    subtitle: 'Créez des quiz, questionnaires et gérez vos événements',
    startFree: 'Commencer gratuitement',
    login: 'Se connecter',
    goToDashboard: 'Accéder au tableau de bord',
    features: {
      quiz: 'Quiz Interactifs',
      quizDesc: 'Créez des quiz captivants avec minuteur et classement',
      quizLive: 'Quiz Live Multi-joueurs',
      quizLiveDesc: 'Animez des quiz en direct avec vos participants connectés simultanément',
      questionnaire: 'Questionnaires Conditionnels',
      questionnaireDesc: 'Formulaires intelligents avec logique conditionnelle et navigation dynamique',
      events: 'Listes de Cadeaux',
      eventsDesc: 'Créez des listes pour mariages, anniversaires, naissances et tous vos événements'
    },
    highlights: {
      timer: 'Timer personnalisable',
      realTimeScores: 'Scores en temps réel',
      kahootMusic: 'Musique Kahoot',
      presenterMode: 'Mode présentateur',
      liveRanking: 'Classement live',
      upTo100Players: "Jusqu'à 100 joueurs",
      conditionalLogic: 'Logique IF/ELSE',
      questionTypes: '11 types de questions',
      responseAnalysis: 'Analyse des réponses',
      multiReservations: 'Réservations multiples',
      photoGallery: 'Galerie photos',
      pdfInvitations: 'Invitations PDF'
    },
    eventTypes: {
      wedding: 'Mariage',
      birthday: 'Anniversaire',
      birth: 'Naissance',
      baptism: 'Baptême',
      housewarming: 'Crémaillère',
      christmas: 'Noël'
    },
    stats: {
      free: 'Gratuit',
      unlimited: 'Quiz illimités',
      questionTypes: 'Types de questions',
      hdImages: 'Images HD'
    },
    cta: {
      createFirstQuiz: 'Créer mon premier quiz',
      discoverFeatures: 'Découvrir les fonctionnalités',
      watchDemo: 'Voir la démo',
      createFreeAccount: 'Créer un compte gratuit',
      readyToCreate: 'Prêt à créer quelque chose d\'incroyable ?',
      joinHugoQuiz: 'Rejoignez HugoQuiz et transformez vos événements en expériences inoubliables.',
      foreverFree: '100% gratuit, pour toujours.'
    },
    footer: {
      madeWith: 'Fait avec',
      forYourEvents: 'pour vos événements',
      createdWith: 'Créé avec'
    },
    sections: {
      allYouNeed: 'Tout ce dont vous avez besoin',
      allYouNeedDesc: 'Une suite complète d\'outils pour créer des expériences interactives inoubliables',
      interactiveQuiz: 'Quiz Interactifs',
      kahootStyle: 'Style Kahoot',
      quizDetailDesc: 'Créez des quiz captivants avec timer, système de score, musique d\'ambiance et classements. Parfait pour l\'éducation, les team buildings ou les soirées entre amis !',
      giftLists: 'Listes de Cadeaux',
      forAllEvents: 'Pour tous vos événements',
      giftListDesc: 'Créez une liste de cadeaux élégante, partagez-la avec vos proches et laissez-les réserver facilement. Galerie photos, histoire personnalisée et invitations PDF incluses !',
      questionTypesTitle: '11 Types de Questions',
      questionTypesDesc: 'Des questions classiques aux formulaires avancés, tout est possible',
      simpleAsHello: 'Simple comme bonjour',
      createShareIn4Steps: 'Créez et partagez en 4 étapes'
    },
    quizFeatures: {
      customTimer: 'Timer personnalisable par question (5-120 sec)',
      kahootMusic: 'Musique d\'ambiance style Kahoot intégrée',
      leaderboardBonus: 'Classement avec bonus de rapidité',
      sevenQuestionTypes: '7 types de questions différents',
      mobileCompatible: 'Compatible mobile et tablette',
      musicOn: 'Musique ON',
      players: 'joueurs'
    },
    giftFeatures: {
      photoGallery: 'Galerie photos avec diaporama animé',
      pdfInvites: 'Invitations PDF personnalisées',
      multiReservations: 'Réservations multiples par cadeau',
      anonymousOption: 'Option anonyme pour les invités',
      reservedBy: 'Réservé par',
      persons: 'personnes'
    },
    howItWorks: {
      step: 'Étape',
      step1Title: 'Inscrivez-vous',
      step1Desc: 'Créez un compte gratuit en 30 secondes',
      step2Title: 'Créez',
      step2Desc: 'Quiz, questionnaire ou liste de cadeaux',
      step3Title: 'Partagez',
      step3Desc: 'Envoyez le lien à vos participants',
      step4Title: 'Analysez',
      step4Desc: 'Consultez les résultats en temps réel'
    },
    navbar: {
      quiz: 'Quiz',
      events: 'Événements',
      gifts: 'Cadeaux',
      interactiveQuiz: 'Quiz Interactifs',
      liveQuiz: 'Quiz Live',
      questionnaires: 'Questionnaires',
      giftLists: 'Listes de Cadeaux',
      features: 'Fonctionnalités'
    },
    // Hero section
    heroTitle: 'Créez des expériences mémorables',
    // Quiz preview mockup
    quizPreview: {
      questionNumber: 'Question 3/10',
      sampleQuestion: 'Quelle est la capitale de la France ?',
      option1: 'Paris',
      option2: 'Londres',
      option3: 'Berlin',
      option4: 'Madrid'
    },
    // Gift list preview mockup
    giftPreview: {
      weddingTitle: 'Mariage de Marie & Pierre',
      weddingDate: '15 juin 2025',
      item1: 'Robot Cuisine',
      item2: 'Service Vaisselle',
      item3: 'Voyage Lune de Miel',
      reservedBy1: 'Tante Sophie'
    },
    // Guest list preview mockup
    guestListPreview: {
      guest1: 'Marie Dupont',
      guest2: 'Pierre Martin',
      guest3: 'Sophie Bernard'
    },
    // Guestbook preview mockup
    guestbookPreview: {
      author1: 'Mamie Jeanne',
      message1: 'Félicitations mes chéris ! 💕',
      author2: 'Thomas & Léa',
      message2: 'Une soirée magique, merci !',
      author3: 'Oncle Jean',
      message3: 'Vive les mariés ! 🥂'
    },
    // Guest list section
    guestList: {
      title: 'Liste des invités',
      persons: 'pers.',
      confirmed: 'confirmés',
      heading: 'Gérez vos invités',
      subheading: 'en toute simplicité',
      description: 'Suivez les confirmations, envoyez des rappels et exportez votre liste. Tout est centralisé pour une organisation parfaite.',
      feature1: 'Invitations personnalisées par email',
      feature2: 'Suivi des confirmations en temps réel',
      feature3: 'Export PDF et Excel'
    },
    // Guestbook section
    guestbook: {
      heading: 'Livre d\'or digital',
      subheading: 'Des souvenirs pour toujours',
      description: 'Vos invités laissent leurs messages et photos. Créez un album de souvenirs unique que vous garderez précieusement.',
      feature1: 'Messages texte et audio',
      feature2: 'Photos et vidéos des invités',
      feature3: 'Design personnalisable',
      bookTitle: 'Livre d\'or'
    },
    // Seating plan section
    seating: {
      heading: 'Plan de salle interactif',
      subheading: 'avec placement par tables',
      description: 'Créez votre plan de salle en glisser-déposer. Assignez vos invités aux tables et visualisez le résultat en temps réel.',
      feature1: 'Interface glisser-déposer intuitive',
      feature2: 'Attribution automatique des places',
      feature3: 'Export et impression du plan',
      preview: 'Plan de salle',
      tables: 'tables',
      seats: 'places',
      dragDrop: 'Glisser-déposer'
    },
    // Pro section
    pro: {
      badge: 'Forfait Pro',
      heading: 'Passez au niveau supérieur',
      description: 'Débloquez toutes les fonctionnalités et profitez de participants illimités pour vos quiz et événements.',
      feature1Title: 'Participants illimités',
      feature1Desc: 'Plus de limite de 5 joueurs',
      feature2Title: 'Questionnaires',
      feature2Desc: 'Créez des sondages complets',
      feature3Title: 'Événements',
      feature3Desc: 'Listes de cadeaux, invités, plan de salle',
      price: 'À partir de 5€',
      period: '/mois',
      cta: 'Voir les forfaits'
    }
  },
  
  // Footer
  footer: {
    description: 'La plateforme interactive pour créer des quiz, questionnaires et gérer vos événements.',
    support: 'Support',
    legal: 'Mentions légales',
    terms: 'Conditions Générales d\'Utilisation',
    privacy: 'Protection des données',
    rights: 'Tous droits réservés.'
  },

  // Privacy Policy Page
  privacy: {
    title: 'Protection des Données Personnelles',
    lastUpdated: 'Dernière mise à jour',
    lastUpdatedDate: '10 janvier 2026',
    intro: {
      title: 'Notre engagement pour votre vie privée',
      description: 'Chez HugoQuiz, la protection de vos données personnelles est notre priorité. Nous nous engageons à traiter vos informations avec le plus grand soin, en conformité avec le Règlement Général sur la Protection des Données (RGPD) et les lois applicables dans l\'Union européenne.'
    },
    section1: {
      title: '1. Responsable du traitement',
      description: 'Le responsable du traitement des données personnelles collectées sur la plateforme HugoQuiz est :',
      website: 'Site web'
    },
    section2: {
      title: '2. Données personnelles collectées',
      description: 'Nous collectons les données suivantes dans le cadre de l\'utilisation de notre plateforme :',
      purpose: 'Finalité',
      legalBasis: 'Base légale',
      retention: 'Durée de conservation',
      security: 'Sécurité',
      email: {
        title: 'Adresse email',
        purpose: 'Création de compte, authentification, envoi de notifications relatives à votre compte et vos abonnements.',
        legalBasis: 'Exécution du contrat (Article 6.1.b du RGPD)',
        retention: 'Pendant toute la durée de votre compte, puis 3 ans après suppression pour obligations légales.'
      },
      username: {
        title: 'Nom d\'utilisateur / Pseudonyme',
        purpose: 'Personnalisation de votre expérience, affichage dans les quiz et événements que vous créez.',
        legalBasis: 'Exécution du contrat (Article 6.1.b du RGPD)',
        retention: 'Pendant toute la durée de votre compte.'
      },
      password: {
        title: 'Mot de passe',
        purpose: 'Sécurisation de l\'accès à votre compte.',
        legalBasis: 'Exécution du contrat (Article 6.1.b du RGPD)',
        security: 'Votre mot de passe est chiffré (hashé) et n\'est jamais stocké en clair. Nous n\'avons aucun accès à votre mot de passe.',
        retention: 'Pendant toute la durée de votre compte.'
      },
      payment: {
        title: 'Données de paiement',
        purpose: 'Traitement des paiements pour les abonnements.',
        legalBasis: 'Exécution du contrat (Article 6.1.b du RGPD)',
        security: 'Nous ne stockons JAMAIS vos données bancaires. Tous les paiements sont traités par Stripe, un prestataire certifié PCI-DSS Level 1 (le plus haut niveau de sécurité).',
        stripeData: 'Données transmises à Stripe',
        stripeDataDesc: 'Uniquement votre email pour associer le paiement à votre compte.'
      },
      connection: {
        title: 'Données de connexion et d\'utilisation',
        dataCollected: 'Données collectées',
        dataCollectedDesc: 'Adresse IP, type de navigateur, pages visitées, date et heure de connexion.',
        purpose: 'Sécurité de la plateforme, amélioration de nos services, statistiques anonymisées.',
        legalBasis: 'Intérêt légitime (Article 6.1.f du RGPD)',
        retention: '12 mois maximum.'
      },
      content: {
        title: 'Contenu créé (Quiz, Questionnaires, Événements)',
        purpose: 'Fourniture du service, sauvegarde de vos créations.',
        legalBasis: 'Exécution du contrat (Article 6.1.b du RGPD)',
        retention: 'Pendant toute la durée de votre abonnement. En cas de non-renouvellement d\'un abonnement payant, les données sont conservées 30 jours avant suppression définitive.'
      }
    },
    section3: {
      title: '3. Vos droits sur vos données',
      description: 'Conformément au RGPD, vous disposez des droits suivants :',
      access: {
        title: 'Droit d\'accès',
        description: 'Obtenir la confirmation que vos données sont traitées et en recevoir une copie.'
      },
      rectification: {
        title: 'Droit de rectification',
        description: 'Demander la correction de données inexactes ou incomplètes.'
      },
      erasure: {
        title: 'Droit à l\'effacement',
        description: 'Demander la suppression de vos données dans les conditions prévues par le RGPD.'
      },
      restriction: {
        title: 'Droit à la limitation',
        description: 'Demander la limitation du traitement de vos données.'
      },
      portability: {
        title: 'Droit à la portabilité',
        description: 'Recevoir vos données dans un format structuré et couramment utilisé.'
      },
      objection: {
        title: 'Droit d\'opposition',
        description: 'Vous opposer au traitement de vos données pour des motifs légitimes.'
      },
      contact: 'Pour exercer ces droits, contactez-nous à'
    },
    section4: {
      title: '4. Sécurité des données',
      description: 'Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données :',
      https: 'Chiffrement HTTPS/TLS',
      httpsDesc: 'Toutes les communications sont chiffrées.',
      hosting: 'Hébergement sécurisé',
      hostingDesc: 'Données hébergées sur les serveurs Firebase (Google Cloud) certifiés ISO 27001.',
      passwords: 'Mots de passe chiffrés',
      passwordsDesc: 'Utilisation d\'algorithmes de hachage sécurisés.',
      accessControl: 'Accès restreint',
      accessControlDesc: 'Seul le personnel autorisé a accès aux données.'
    },
    section5: {
      title: '5. Transferts de données',
      description: 'Vos données peuvent être traitées par les sous-traitants suivants, tous conformes au RGPD :',
      subcontractor: 'Sous-traitant',
      purposeCol: 'Finalité',
      location: 'Localisation',
      firebase: 'Hébergement, base de données',
      firebaseLocation: 'UE (europe-west)',
      stripe: 'Paiements',
      stripeLocation: 'UE / USA (SCC)',
      brevo: 'Envoi d\'emails',
      brevoLocation: 'France'
    },
    section6: {
      title: '6. Cookies',
      description: 'Notre plateforme utilise uniquement des cookies techniques essentiels au fonctionnement du service :',
      authCookie: 'Cookie d\'authentification',
      authCookieDesc: 'Maintien de votre session de connexion.',
      preferences: 'Préférences',
      preferencesDesc: 'Langue sélectionnée.',
      noTracking: 'Nous n\'utilisons pas de cookies publicitaires ni de cookies de suivi tiers.'
    },
    section7: {
      title: '7. Durée de conservation',
      description: 'Vos données sont conservées selon les durées suivantes :',
      dataType: 'Type de données',
      retentionPeriod: 'Durée de conservation',
      accountData: 'Données de compte (email, nom)',
      accountDataRetention: 'Durée du compte + 3 ans',
      createdContent: 'Contenu créé (quiz, événements)',
      createdContentRetention: 'Durée de l\'abonnement + 30 jours',
      paymentData: 'Données de paiement',
      paymentDataRetention: '10 ans (obligation légale comptable)',
      connectionLogs: 'Logs de connexion',
      connectionLogsRetention: '12 mois'
    },
    section8: {
      title: '8. Contact et réclamations',
      description: 'Pour toute question concernant la protection de vos données ou pour exercer vos droits, vous pouvez nous contacter à :',
      complaint: 'Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la CNIL (Commission Nationale de l\'Informatique et des Libertés) :'
    }
  },

  // Terms of Use Page (CGU)
  cgu: {
    title: 'Conditions Générales d\'Utilisation',
    lastUpdated: 'Dernière mise à jour',
    lastUpdatedDate: '10 janvier 2026',
    article1: {
      title: 'ARTICLE 1 – OBJET ET CHAMP D\'APPLICATION',
      p1: '1.1. Les présentes Conditions Générales d\'Utilisation (ci-après dénommées "CGU") ont pour objet de définir les modalités et conditions dans lesquelles la société HugoQuiz (ci-après dénommée "l\'Éditeur") met à disposition de ses utilisateurs (ci-après dénommés "l\'Utilisateur" ou "les Utilisateurs") la plateforme accessible à l\'adresse https://hugoquiz.com (ci-après dénommée "la Plateforme").',
      p2: '1.2. L\'accès et l\'utilisation de la Plateforme sont subordonnés à l\'acceptation sans réserve des présentes CGU. L\'Utilisateur reconnaît avoir pris connaissance des présentes CGU préalablement à toute utilisation de la Plateforme et s\'engage à les respecter sans restriction ni réserve.',
      p3: '1.3. Les présentes CGU sont applicables à tout Utilisateur de la Plateforme, qu\'il soit titulaire d\'un compte gratuit ou d\'un abonnement payant.'
    },
    article2: {
      title: 'ARTICLE 2 – DÉFINITIONS',
      subscription: 'Abonnement',
      subscriptionDef: 'désigne la souscription par l\'Utilisateur à l\'une des formules payantes proposées par l\'Éditeur, conférant l\'accès à des fonctionnalités étendues de la Plateforme.',
      userAccount: 'Compte Utilisateur',
      userAccountDef: 'désigne l\'espace personnel de l\'Utilisateur, accessible au moyen d\'identifiants de connexion, permettant l\'accès aux Services.',
      services: 'Services',
      servicesDef: 'désigne l\'ensemble des fonctionnalités et services proposés par la Plateforme, incluant notamment la création de quiz, questionnaires et la gestion d\'événements.',
      subscriptionPeriod: 'Période d\'Abonnement',
      subscriptionPeriodDef: 'désigne la durée pendant laquelle l\'Utilisateur bénéficie des Services associés à son Abonnement, débutant à la date de souscription.'
    },
    article3: {
      title: 'ARTICLE 3 – INSCRIPTION ET COMPTE UTILISATEUR',
      p1: '3.1. L\'accès à certaines fonctionnalités de la Plateforme est conditionné à la création préalable d\'un Compte Utilisateur. L\'inscription est gratuite et s\'effectue en complétant le formulaire d\'inscription disponible sur la Plateforme.',
      p2: '3.2. L\'Utilisateur s\'engage à fournir des informations exactes, à jour et complètes lors de son inscription. Il s\'engage également à mettre à jour ces informations en cas de modification.',
      p3: '3.3. L\'Utilisateur est seul responsable de la confidentialité de ses identifiants de connexion et de toutes les activités effectuées depuis son Compte Utilisateur.'
    },
    article4: {
      title: 'ARTICLE 4 – ABONNEMENTS ET CONDITIONS TARIFAIRES',
      p1: '4.1. La Plateforme propose différentes formules d\'Abonnement, dont les caractéristiques et tarifs sont précisés sur la page dédiée aux tarifs. Les prix sont indiqués en euros, toutes taxes comprises (TTC).',
      p2: '4.2. Le paiement de l\'Abonnement s\'effectue par carte bancaire via la plateforme de paiement sécurisé Stripe. L\'Abonnement prend effet immédiatement après la validation du paiement.',
      p3: '4.3. Sauf résiliation dans les conditions prévues à l\'Article 5, l\'Abonnement est reconduit tacitement pour une durée identique à la Période d\'Abonnement initiale. Le prélèvement du montant de l\'Abonnement est effectué automatiquement à chaque date anniversaire de souscription.'
    },
    article4bis: {
      title: 'ARTICLE 4 BIS – ESSAI GRATUIT',
      section1Title: '4 bis.1. CONDITIONS DE L\'ESSAI GRATUIT',
      section1Desc: 'L\'Éditeur propose aux nouveaux Utilisateurs la possibilité de bénéficier d\'une période d\'essai gratuit de SEPT (7) JOURS pour tout Abonnement mensuel. Cette offre est soumise aux conditions suivantes :',
      section1Item1: 'L\'essai gratuit n\'est disponible qu\'UNE SEULE FOIS par Utilisateur, quel que soit le forfait choisi ;',
      section1Item2: 'Si l\'Utilisateur active un essai gratuit sur un forfait, il perd définitivement le droit à l\'essai gratuit sur tous les autres forfaits ;',
      section1Item3: 'L\'enregistrement d\'un moyen de paiement (carte bancaire) est obligatoire pour activer l\'essai gratuit ;',
      section1Item4: 'L\'Utilisateur ayant bénéficié d\'un accès premium offert par l\'administrateur ne peut pas bénéficier de l\'essai gratuit.',
      section2Title: '4 bis.2. DURÉE ET FONCTIONNEMENT',
      section2Desc: 'Pendant la période d\'essai de sept (7) jours :',
      section2Item1: 'L\'Utilisateur bénéficie de toutes les fonctionnalités du forfait choisi ;',
      section2Item2: 'Aucun prélèvement n\'est effectué pendant la durée de l\'essai ;',
      section2Item3: 'L\'Utilisateur peut résilier à tout moment avant la fin de la période d\'essai sans frais.',
      section3Title: '4 bis.3. FIN DE LA PÉRIODE D\'ESSAI',
      section3Desc: 'À l\'issue de la période d\'essai de sept (7) jours :',
      section3Item1: 'Le premier prélèvement sera automatiquement effectué à 00h00 (heure de Paris) le huitième (8ème) jour suivant l\'activation de l\'essai ;',
      section3Item2: 'L\'Abonnement sera ensuite reconduit tacitement selon les conditions prévues à l\'Article 4.3 ;',
      section3Item3: 'L\'Utilisateur sera notifié par email avant la fin de la période d\'essai.',
      section4Title: '4 bis.4. RÉSILIATION PENDANT L\'ESSAI',
      section4Desc: 'L\'Utilisateur peut résilier son essai gratuit à tout moment pendant les sept (7) jours via son espace personnel. En cas de résiliation pendant la période d\'essai :',
      section4Item1: 'Aucun prélèvement ne sera effectué ;',
      section4Item2: 'L\'accès aux fonctionnalités premium prendra fin immédiatement ;',
      section4Item3: 'L\'Utilisateur ne pourra plus bénéficier d\'un nouvel essai gratuit, même sur un autre forfait.',
      section5Title: '4 bis.5. PROTECTION CONTRE LES ABUS',
      section5Desc: 'Afin de prévenir tout abus, l\'Éditeur met en place les mesures de protection suivantes :',
      section5Item1: 'L\'éligibilité à l\'essai gratuit est vérifiée côté serveur et ne peut être contournée ;',
      section5Item2: 'L\'annulation de l\'essai gratuit ne permet pas d\'en activer un nouveau ;',
      section5Item3: 'L\'Éditeur se réserve le droit de refuser ou d\'annuler un essai gratuit en cas de suspicion de fraude.'
    },
    article5: {
      title: 'ARTICLE 5 – DROIT DE RÉTRACTATION, RÉSILIATION ET REMBOURSEMENT',
      section1Title: '5.1. DROIT DE RÉTRACTATION LIMITÉ',
      section1Desc: 'Conformément aux dispositions de l\'article L.221-28 du Code de la consommation, et compte tenu de la nature des Services proposés (contenu numérique non fourni sur un support matériel dont l\'exécution a commencé avec l\'accord préalable exprès du consommateur), l\'Utilisateur bénéficie d\'un droit de rétractation limité dans les conditions suivantes :',
      section1Important: 'Le remboursement intégral de l\'Abonnement n\'est possible que si la demande d\'annulation est effectuée dans un délai de TRENTE (30) MINUTES suivant la souscription initiale de l\'Abonnement. Passé ce délai, aucun remboursement ne pourra être accordé pour la Période d\'Abonnement en cours.',
      section2Title: '5.2. RÉSILIATION DU RENOUVELLEMENT',
      section2Desc: 'L\'Utilisateur peut à tout moment, et sans aucune restriction de délai, décider de ne pas renouveler son Abonnement depuis son espace personnel :',
      section2Important: 'L\'annulation du renouvellement automatique est possible à TOUT MOMENT, y compris dans les heures précédant la date de renouvellement. Une fois l\'annulation effectuée, aucun nouveau prélèvement ne sera réalisé et l\'Utilisateur conserve l\'accès aux Services jusqu\'à la fin de la Période d\'Abonnement en cours. Aucun remboursement n\'est effectué.',
      section3Title: '5.3. ABSENCE DE REMBOURSEMENT',
      section3Desc: 'L\'Utilisateur conserve le droit de résilier son Abonnement à tout moment. Néanmoins, si la résiliation intervient :',
      section3Item1: 'Plus de trente (30) minutes après la souscription initiale ; ou',
      section3Item2: 'Après le début d\'une Période d\'Abonnement déjà payée ; ou',
      section3Item3: 'Après un renouvellement automatique de l\'Abonnement',
      section3NoRefund: 'Aucun remboursement, même partiel ou au prorata temporis, ne sera accordé.',
      section4Title: '5.4. PRÉCISIONS IMPORTANTES',
      section4Desc: 'Le droit de rétractation avec remboursement de trente (30) minutes s\'applique exclusivement à la souscription initiale d\'un Abonnement et ne s\'applique pas aux renouvellements automatiques subséquents.',
      section5Title: '5.5. RÉSILIATION IMMÉDIATE DU FORFAIT',
      section5Desc: 'L\'Utilisateur peut, à tout moment et sans restriction, résilier immédiatement son forfait depuis son espace personnel. Dans ce cas :',
      section5Item1: 'La perte des avantages et fonctionnalités du forfait est IMMÉDIATE ;',
      section5Item2: 'Aucun remboursement, même partiel, n\'est possible ;',
      section5Item3: 'L\'Utilisateur revient immédiatement au forfait gratuit et reçoit une confirmation par email.'
    },
    article6: {
      title: 'ARTICLE 6 – OBLIGATIONS DE L\'UTILISATEUR',
      p1: '6.1. L\'Utilisateur s\'engage à utiliser la Plateforme conformément à sa destination et dans le respect des lois et règlements en vigueur.',
      p2: '6.2. L\'Utilisateur s\'interdit notamment de :',
      item1: 'Utiliser la Plateforme à des fins illicites, frauduleuses ou portant atteinte aux droits de tiers ;',
      item2: 'Tenter d\'accéder sans autorisation aux systèmes informatiques de l\'Éditeur ;',
      item3: 'Diffuser des contenus illicites, diffamatoires, injurieux ou contraires à l\'ordre public ;',
      item4: 'Reproduire, copier ou exploiter commercialement tout ou partie de la Plateforme sans autorisation préalable.',
      p3: '6.3. L\'Utilisateur s\'engage à respecter les quotas d\'utilisation du stockage définis à l\'Article 6 bis.'
    },
    article6bis: {
      title: 'ARTICLE 6 BIS – QUOTA DE STOCKAGE',
      p1: '6 bis.1. Chaque Utilisateur dispose d\'un espace de stockage personnel limité à deux gigaoctets (2 Go) pour l\'ensemble des fichiers téléchargés sur la Plateforme (images, photos, documents, contenus multimédias, etc.). Ce quota s\'applique de manière cumulative à l\'ensemble des Services utilisés (Quiz, Questionnaires, Événements).',
      p2: '6 bis.2. L\'Utilisateur est tenu de surveiller son utilisation du stockage via l\'interface dédiée dans les paramètres de son compte. Un indicateur de consommation est disponible à tout moment.',
      p3: '6 bis.3. Lorsque l\'Utilisateur atteint quatre-vingt-dix pour cent (90%) de son quota de stockage, une notification d\'avertissement lui sera adressée. Lorsque le quota de deux gigaoctets (2 Go) est atteint, l\'Utilisateur ne pourra plus télécharger de nouveaux fichiers jusqu\'à ce qu\'il libère de l\'espace ou obtienne une extension de quota.',
      p4: '6 bis.4. L\'extension du quota de stockage au-delà de la limite de deux gigaoctets (2 Go) est laissée à la discrétion exclusive de l\'Éditeur. L\'Utilisateur peut formuler une demande d\'extension par écrit à l\'adresse',
      p4b: 'L\'Éditeur se réserve le droit d\'accorder ou de refuser toute demande d\'extension, avec ou sans justification.',
      p5: '6 bis.5. L\'Éditeur se réserve le droit de supprimer, après notification préalable de trente (30) jours, les fichiers des comptes inactifs depuis plus de douze (12) mois consécutifs, afin de garantir une utilisation optimale des ressources de stockage.'
    },
    article7: {
      title: 'ARTICLE 7 – PROPRIÉTÉ INTELLECTUELLE',
      p1: '7.1. L\'ensemble des éléments constituant la Plateforme (textes, graphismes, logiciels, photographies, images, vidéos, sons, plans, noms, logos, marques, créations et œuvres protégeables diverses, bases de données, etc.) ainsi que la Plateforme elle-même sont la propriété exclusive de l\'Éditeur ou de ses partenaires.',
      p2: '7.2. Ces éléments sont protégés par les lois relatives à la propriété intellectuelle et notamment le droit d\'auteur. Toute reproduction, représentation, utilisation ou adaptation, sous quelque forme que ce soit, de tout ou partie de ces éléments, sans l\'accord préalable et écrit de l\'Éditeur, est strictement interdite.'
    },
    article8: {
      title: 'ARTICLE 8 – LIMITATION DE RESPONSABILITÉ',
      p1: '8.1. L\'Éditeur s\'engage à mettre en œuvre tous les moyens nécessaires pour assurer la continuité et la qualité des Services. Toutefois, l\'Éditeur ne saurait être tenu responsable des interruptions temporaires de la Plateforme pour des raisons techniques, de maintenance ou en cas de force majeure.',
      p2: '8.2. L\'Éditeur ne saurait être tenu responsable des dommages directs ou indirects résultant de l\'utilisation de la Plateforme par l\'Utilisateur, notamment en cas de perte de données, d\'interruption d\'activité ou de tout autre préjudice.'
    },
    article9: {
      title: 'ARTICLE 9 – PROTECTION DES DONNÉES PERSONNELLES',
      p1: '9.1. L\'Éditeur s\'engage à respecter la vie privée des Utilisateurs et à traiter les données personnelles conformément au Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 (Règlement Général sur la Protection des Données - RGPD).',
      p2: '9.2. Les modalités de collecte, de traitement et de protection des données personnelles sont détaillées dans la Politique de Protection des Données, accessible depuis la Plateforme.'
    },
    article10: {
      title: 'ARTICLE 10 – MODIFICATION DES CGU',
      p1: '10.1. L\'Éditeur se réserve le droit de modifier à tout moment les présentes CGU. Les modifications entrent en vigueur dès leur publication sur la Plateforme.',
      p2: '10.2. L\'Utilisateur sera informé de toute modification substantielle des CGU par tout moyen approprié. La poursuite de l\'utilisation de la Plateforme après notification des modifications vaut acceptation des nouvelles CGU.'
    },
    article10bis: {
      title: 'ARTICLE 10 BIS – SUPPRESSION DE COMPTE',
      section1Title: '10 bis.1. DROIT À LA SUPPRESSION',
      section1Desc: 'L\'Utilisateur dispose à tout moment du droit de demander la suppression de son Compte Utilisateur. Cette demande peut être effectuée directement depuis la page "Profil" de la Plateforme, en cliquant sur le bouton "Supprimer mon compte".',
      section2Title: '10 bis.2. EFFETS DE LA SUPPRESSION',
      section2Warning: 'La suppression du compte est IRRÉVERSIBLE. Une fois confirmée, la suppression entraîne :',
      section2Item1: 'La suppression définitive de tous les quiz créés par l\'Utilisateur ;',
      section2Item2: 'La suppression définitive de tous les questionnaires créés par l\'Utilisateur ;',
      section2Item3: 'La suppression définitive de tous les événements et leurs données associées (invités, plan de salle, livre d\'or) ;',
      section2Item4: 'La suppression définitive des données personnelles de l\'Utilisateur ;',
      section2Item5: 'L\'impossibilité de récupérer le compte ou les données supprimées.',
      section3Title: '10 bis.3. COMPTES GRATUITS',
      section3Desc: 'Pour les Utilisateurs disposant d\'un compte gratuit, la suppression est effective immédiatement après confirmation.',
      section4Title: '10 bis.4. COMPTES AVEC ABONNEMENT PAYANT',
      section4Warning: 'AVERTISSEMENT IMPORTANT : Si l\'Utilisateur dispose d\'un Abonnement payant souscrit via Stripe et que le renouvellement automatique est prévu dans un délai de MOINS DE QUARANTE-HUIT (48) HEURES, et que l\'Utilisateur n\'a pas préalablement annulé ce renouvellement :',
      section4Item1: 'Le prélèvement du montant de l\'Abonnement pour la période suivante SERA EFFECTUÉ malgré la demande de suppression ;',
      section4Item2: 'Aucun remboursement ne sera accordé pour ce prélèvement ;',
      section4Item3: 'Le compte sera néanmoins marqué comme supprimé et l\'Utilisateur n\'aura plus accès à la Plateforme ;',
      section4Item4: 'La suppression définitive des données interviendra après le traitement du paiement.',
      section5Title: '10 bis.5. RECOMMANDATION',
      section5Desc: 'Il est vivement recommandé à l\'Utilisateur souhaitant supprimer son compte de :',
      section5Item1: 'D\'abord annuler le renouvellement de son Abonnement (au moins 48 heures avant la date de renouvellement) ;',
      section5Item2: 'Attendre la fin de la période d\'Abonnement en cours ;',
      section5Item3: 'Puis procéder à la suppression du compte.',
      section6Title: '10 bis.6. COMPTES AVEC ACCÈS ACCORDÉ PAR L\'ADMINISTRATEUR',
      section6Desc: 'Pour les Utilisateurs bénéficiant d\'un accès premium accordé gratuitement par l\'administrateur, la suppression du compte est effective immédiatement après confirmation, sans aucun prélèvement.'
    },
    article11: {
      title: 'ARTICLE 11 – LOI APPLICABLE ET JURIDICTION COMPÉTENTE',
      p1: '11.1. Les présentes CGU sont régies par le droit français et le droit de l\'Union européenne.',
      p2: '11.2. En cas de litige relatif à l\'interprétation, l\'exécution ou la résiliation des présentes CGU, et à défaut de résolution amiable, les tribunaux français seront seuls compétents.',
      p3: '11.3. Conformément aux dispositions du Code de la consommation concernant le règlement amiable des litiges, l\'Utilisateur peut recourir au service de médiation proposé par l\'Éditeur. Le médiateur peut être saisi via l\'adresse électronique : contact@hugoquiz.com'
    },
    article12: {
      title: 'ARTICLE 12 – CONTACT',
      desc: 'Pour toute question relative aux présentes CGU ou aux Services, l\'Utilisateur peut contacter l\'Éditeur à l\'adresse suivante :'
    },
    servicesSection: {
      title: 'Article 10 ter - Place de marché « Services »',
      purposeTitle: 'Objet',
      purpose: "HugoQuiz met à disposition une place de marché permettant à des utilisateurs (les « Prestataires ») de proposer leurs services à d'autres utilisateurs ou visiteurs. HugoQuiz agit uniquement en qualité d'hébergeur technique de mise en relation et n'est pas partie aux contrats conclus entre Prestataires et clients. La consultation des services est libre ; la création d'un service nécessite un compte et la vérification préalable de l'identité du Prestataire.",
      verificationTitle: "Vérification d'identité",
      verification: "Pour publier un service, le Prestataire doit fournir une pièce d'identité officielle en cours de validité (carte d'identité, passeport de l'Union européenne, carte de séjour, visa ou permis de conduire) ainsi qu'une courte vidéo selfie. Ces éléments servent exclusivement à confirmer que l'identité déclarée correspond bien à la personne. Tout service est soumis à validation par notre équipe avant publication.",
      prohibitedTitle: 'Services interdits',
      prohibitedIntro: "Sont strictement interdits et feront l'objet d'un refus, d'une restriction ou d'une suppression immédiate, sans préjudice de poursuites :",
      prohibited1: "tout service à caractère sexuel, pornographique ou d'escorte ;",
      prohibited2: "la vente, la production ou la distribution de drogues, de stupéfiants ou de substances illicites ;",
      prohibited3: "la vente d'armes, d'explosifs ou de produits dangereux réglementés ;",
      prohibited4: "tout service contraire à la loi ou illégal dans l'Union européenne ou dans le pays d'exécution ;",
      prohibited5: "les contenus ou activités incitant à la haine, à la violence, à la discrimination ou portant atteinte aux droits d'autrui ;",
      prohibited6: "toute escroquerie, contrefaçon, blanchiment ou activité frauduleuse.",
      responsibilityTitle: 'Responsabilité des Prestataires',
      responsibility: "Le Prestataire est seul responsable de la légalité, de l'exactitude et de l'exécution des services qu'il propose, ainsi que du respect de ses obligations légales, fiscales et réglementaires. HugoQuiz se réserve le droit de modérer, restreindre ou supprimer tout service, et de suspendre tout compte, en cas de manquement aux présentes conditions, avec notification automatique de l'utilisateur concerné.",
      dataTitle: 'Données et formulaire de contact',
      data: "Les coordonnées affichées publiquement (e-mail, téléphone) le sont au choix du Prestataire. Lorsqu'un visiteur envoie une demande via le formulaire de contact d'un service, les informations qu'il fournit (nom, téléphone, type de client, objet et description de la demande) sont transmises au Prestataire concerné par notification et par e-mail afin de permettre la mise en relation. En soumettant le formulaire, l'utilisateur consent expressément à ce traitement et à cette transmission. Les pièces d'identité et vidéos de vérification sont conservées de manière confidentielle et ne sont accessibles qu'à l'équipe de modération de HugoQuiz, conformément à la politique de confidentialité."
    }
  },
  
  // Auth
  auth: {
    email: 'Email',
    emailPlaceholder: 'votre@email.com',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    displayName: "Nom d'affichage",
    displayNamePlaceholder: 'Jean Dupont',
    firstName: 'Prénom',
    lastName: 'Nom',
    loginTitle: 'Connexion',
    registerTitle: 'Créer un compte',
    loginButton: 'Se connecter',
    registerButton: "S'inscrire",
    forgotPassword: 'Mot de passe oublié ?',
    forgotPasswordTitle: 'Mot de passe oublié',
    resetPasswordDesc: 'Entrez votre email pour réinitialiser',
    noAccount: "Pas encore de compte ?",
    hasAccount: 'Déjà un compte ?',
    pendingValidation: 'Compte en attente de validation',
    pendingMessage: 'Votre compte est en cours de validation par un administrateur.',
    backToHome: "Retour à l'accueil",
    backToLogin: 'Retour à la connexion',
    welcomeTo: 'Bienvenue sur',
    joinHugoQuiz: 'Rejoignez HugoQuiz',
    createAccount: 'Créer mon compte',
    sendResetLink: 'Envoyer le lien',
    passwordRequirements: {
      minLength: 'Au moins 6 caractères',
      uppercase: 'Une majuscule',
      number: 'Un chiffre'
    },
    errors: {
      fillAllFields: 'Veuillez remplir tous les champs',
      fillAddressFields: "Veuillez remplir tous les champs d'adresse",
      passwordMin6: 'Le mot de passe doit contenir au moins 6 caractères',
      passwordNoMatch: 'Les mots de passe ne correspondent pas',
      userNotFound: 'Aucun compte trouvé avec cet email',
      wrongPassword: 'Mot de passe incorrect',
      invalidCredential: 'Email ou mot de passe incorrect',
      connectionError: 'Erreur de connexion',
      emailAlreadyUsed: 'Cet email est déjà utilisé',
      invalidEmail: 'Email invalide',
      invalidEmailFormat: "Format d'email invalide",
      weakPassword: 'Mot de passe trop faible',
      registerError: "Erreur lors de l'inscription",
      enterEmail: 'Veuillez entrer votre email',
      noAccountForEmail: 'Aucun compte associé à cet email',
      tooManyAttempts: 'Trop de tentatives. Réessayez plus tard.',
      resetError: "Erreur lors de l'envoi de l'email"
    },
    success: {
      loginSuccess: 'Connexion réussie !',
      resetEmailSent: 'Email de réinitialisation envoyé ! Vérifiez votre boîte de réception et vos spams.',
      verificationSent: 'Un email de vérification a été envoyé à'
    },
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    loginError: 'Email ou mot de passe incorrect',
    registerError: "Erreur lors de l'inscription",
    emailInUse: 'Cet email est déjà utilisé',
    invalidEmail: 'Email invalide',
    weakPassword: 'Mot de passe trop faible',
    verificationSent: 'Un email de vérification a été envoyé à',
    adminValidation: 'Après inscription, votre compte devra être validé par un administrateur avant de pouvoir accéder à l\'application.',
    resetPassword: 'Réinitialiser le mot de passe',
    resetPasswordSent: 'Email de réinitialisation envoyé',
    resetPasswordError: 'Erreur lors de l\'envoi de l\'email',
    // Address fields
    address: {
      title: 'Adresse de livraison',
      street: 'Rue',
      streetNumber: 'Numéro',
      postalCode: 'Code postal (Boîte postale)',
      city: 'Ville',
      nameAtAddress: 'Nom à l\'adresse',
      nameAtAddressHint: 'Nom qui apparaîtra sur les livraisons',
      postalNotRecognized: 'Code postal non reconnu mais accepté'
    }
  },
  
  // Dashboard
  dashboard: {
    title: 'Tableau de bord',
    welcome: 'Bienvenue',
    hello: 'Bonjour',
    manageContent: 'Gérez vos quiz et questionnaires',
    myQuizzes: 'Mes Quiz',
    myQuestionnaires: 'Mes Questionnaires',
    myEvents: 'Mes Événements',
    createQuiz: 'Créer un Quiz',
    createQuestionnaire: 'Créer un Questionnaire',
    createEvent: 'Créer un Événement',
    noQuizzes: "Vous n'avez pas encore créé de quiz",
    noQuestionnaires: "Vous n'avez pas encore créé de questionnaire",
    noEvents: "Vous n'avez pas encore créé d'événement",
    noQuizzesDesc: 'Créez votre premier quiz interactif',
    noQuestionnairesDesc: 'Créez votre premier questionnaire',
    noEventsDesc: 'Créez votre premier événement',
    createFirstQuiz: 'Créer mon premier quiz',
    createFirstQuestionnaire: 'Créer mon premier questionnaire',
    createFirstEvent: 'Créer mon premier événement',
    recentActivity: 'Activité récente',
    quickActions: 'Actions rapides',
    noDescription: 'Aucune description',
    dateNotSet: 'Date non définie',
    stats: {
      quizzesCreated: 'Quiz créés',
      questionnaires: 'Questionnaires',
      events: 'Événements',
      totalContent: 'Total contenus',
      totalQuizzes: 'Total Quiz',
      totalQuestionnaires: 'Total Questionnaires',
      totalEvents: 'Total Événements',
      totalResponses: 'Total Réponses',
      totalParticipants: 'Total Participants',
      totalGuests: 'Total Invités'
    },
    storage: {
      warning: 'Espace de stockage bientôt plein',
      critical: 'Espace de stockage critique !',
      exceeded: 'Espace de stockage épuisé !',
      usageInfo: 'Vous utilisez {{used}} sur {{limit}} ({{percentage}}%)',
      contactAdmin: 'Contactez contact@hugoquiz.com pour augmenter votre espace.'
    },
    tabs: {
      quiz: 'Quiz',
      questionnaires: 'Questionnaires',
      events: 'Événements',
      services: 'Services'
    },
    actions: {
      hostLive: 'Animer en direct',
      viewResponses: 'Voir les réponses',
      share: 'Partager',
      play: 'Jouer',
      answer: 'Répondre',
      edit: 'Modifier',
      delete: 'Supprimer',
      manageGuests: 'Gérer les invités',
      statistics: 'Statistiques',
      view: 'Voir'
    },
    actionPanel: {
      hostLive: 'Lancer en direct',
      testQuiz: 'Tester le quiz',
      viewResults: 'Voir les résultats',
      share: 'Partager',
      edit: 'Modifier',
      delete: 'Supprimer',
      viewResponses: 'Voir les réponses',
      test: 'Tester',
      guestList: 'Liste des invités',
      planning: 'Planification',
      tasks: 'Tâches',
      statistics: 'Statistiques',
      shareGiftList: 'Partager',
      viewGiftList: 'Consulter'
    },
    share: {
      title: 'Partager',
      whatsapp: 'Partager sur WhatsApp',
      email: 'Envoyer par Email',
      copyLink: 'Copier le lien',
      linkCopied: 'Lien copié !',
      copyError: 'Impossible de copier le lien',
      quizMessage: 'Venez jouer à mon quiz',
      questionnaireMessage: 'Répondez à mon questionnaire',
      eventMessage: 'Consultez notre liste de cadeaux',
      quizEmailSubject: 'Invitation à jouer au quiz',
      quizEmailBody: 'Bonjour,\n\nJe vous invite à jouer à mon quiz "{title}" !\n\nCliquez sur le lien suivant pour commencer :\n{link}\n\nBonne chance ! 🎯',
      questionnaireEmailSubject: 'Invitation à répondre au questionnaire',
      questionnaireEmailBody: 'Bonjour,\n\nJe vous invite à répondre à mon questionnaire "{title}".\n\nCliquez sur le lien suivant pour participer :\n{link}\n\nMerci pour votre participation ! 📋',
      eventEmailSubject: 'Liste de cadeaux',
      eventEmailBody: 'Bonjour,\n\nVous êtes invité(e) à consulter notre liste de cadeaux pour "{title}" !\n\nCliquez sur le lien suivant pour voir la liste et réserver un cadeau :\n{link}\n\nMerci beaucoup ! 🎁'
    },
    deleteModal: {
      title: 'Confirmer la suppression',
      message: 'Êtes-vous sûr de vouloir supprimer "{title}" ? Cette action est irréversible.',
      cancel: 'Annuler',
      confirm: 'Supprimer',
      success: 'Supprimé avec succès',
      error: 'Erreur lors de la suppression'
    },
    eventTypes: {
      mariage: 'Mariage',
      anniversaire: 'Anniversaire',
      naissance: 'Naissance',
      bapteme: 'Baptême',
      cremaillere: 'Crémaillère',
      noel: 'Noël',
      autre: 'Autre'
    },
    loading: 'Chargement...',
    loadError: 'Erreur lors du chargement des données'
  },
  
  // Quiz
  quiz: {
    title: 'Titre du quiz',
    description: 'Description',
    questions: 'Questions',
    question: 'Question',
    answers: 'Réponses',
    answer: 'Réponse',
    correctAnswer: 'Bonne réponse',
    correctAnswers: 'Bonnes réponses',
    wrongAnswer: 'Mauvaise réponse',
    timeLimit: 'Temps limite',
    timeLimitSeconds: 'secondes',
    points: 'Points',
    point: 'Point',
    addQuestion: 'Ajouter une question',
    editQuestion: 'Modifier la question',
    deleteQuestion: 'Supprimer la question',
    play: 'Jouer au quiz',
    playLive: 'Quiz Live',
    playPractice: 'Mode entraînement',
    results: 'Résultats',
    score: 'Score',
    leaderboard: 'Classement',
    yourAnswer: 'Votre réponse',
    correct: 'Correct',
    incorrect: 'Incorrect',
    timeUp: 'Temps écoulé !',
    nextQuestion: 'Question suivante',
    finish: 'Terminer',
    reviewMode: 'Mode révision',
    showAll: 'Voir tout',
    wrongAnswers: 'réponse(s) incorrecte(s)',
    true: 'Vrai',
    false: 'Faux',
    // Play mode translations
    yourName: 'Votre nom',
    enterNamePlaceholder: 'Entrez votre nom...',
    prepareToPlay: 'Préparez-vous à jouer !',
    loading: 'Chargement du quiz...',
    checkAllCorrect: 'Cochez toutes les bonnes réponses',
    validateAnswer: 'Valider ma réponse',
    selectAnswer: '-- Sélectionnez une réponse --',
    correctAnswerWas: 'La bonne réponse était',
    typeYourAnswer: 'Tapez votre réponse...',
    enterNumber: 'Entrez un nombre...',
    validate: 'Valider',
    selectAtLeastOne: 'Sélectionnez au moins une réponse',
    enterAnswer: 'Entrez une réponse',
    enterValidNumber: 'Entrez un nombre valide',
    selectRating: 'Sélectionnez une note',
    puzzleReorder: 'Remettez dans l\'ordre',
    puzzleInstruction: 'Utilisez les flèches pour réordonner les éléments',
    validateOrder: 'Valider mon ordre',
    correctOrder: 'Ordre correct',
    bravo: 'Bravo',
    answerDetails: 'Détail des réponses',
    replay: 'Rejouer',
    questionTypes: {
      singleChoice: 'Choix unique',
      singleChoiceDesc: 'Une seule réponse possible',
      multipleChoice: 'Plusieurs réponses',
      multipleChoiceDesc: 'Plusieurs réponses possibles',
      trueFalse: 'Vrai ou Faux',
      trueFalseDesc: 'Question vrai ou faux',
      dropdown: 'Liste déroulante',
      dropdownDesc: 'Sélection dans une liste',
      shortText: 'Réponse texte',
      shortTextDesc: 'Réponse courte libre',
      number: 'Réponse numérique',
      numberDesc: 'Un nombre comme réponse',
      rating: 'Évaluation',
      ratingDesc: 'Note sur une échelle',
      puzzle: 'Remise en ordre',
      puzzleDesc: 'Remettre les éléments dans l\'ordre'
    },
    create: {
      title: 'Créer un quiz',
      editTitle: 'Modifier le quiz',
      editSubtitle: 'Modifiez les questions et paramètres',
      quizInfo: 'Informations du Quiz',
      quizTitle: 'Titre du quiz',
      quizTitlePlaceholder: 'Ex: Quiz culture générale',
      quizDescription: 'Description (optionnel)',
      quizDescriptionPlaceholder: 'Décrivez votre quiz...',
      defaultTime: 'Temps par défaut par question',
      timeSeconds: 'Temps (sec)',
      isPublic: 'Quiz public',
      isPublicDesc: 'Visible par tous les utilisateurs',
      showAnswers: 'Montrer réponses',
      shuffle: 'Mélanger',
      addImage: 'Ajouter une image',
      questionText: 'Texte de la question',
      questionTextPlaceholder: 'Entrez votre question...',
      noQuestionText: 'Question sans texte',
      questionImage: 'Image de la question',
      imageTip: 'L\'image sera affichée aux joueurs pendant la question',
      questionType: 'Type de question',
      answerOptions: 'Options de réponse',
      answerPlaceholder: 'Réponse',
      addOption: 'Ajouter une option',
      addAnswer: 'Ajouter une réponse',
      addElement: 'Ajouter un élément',
      markCorrect: 'Marquer comme correcte',
      puzzleElements: 'Éléments à ordonner',
      puzzleOrderHint: 'l\'ordre affiché ici = le bon ordre',
      puzzleTip: 'Entrez les éléments dans le BON ORDRE. Les joueurs les verront mélangés et devront les remettre dans cet ordre.',
      acceptedAnswers: 'Bonnes réponses acceptées',
      acceptedAnswersPlaceholder: 'Entrez les réponses acceptées séparées par des virgules...\nExemple: Paris, paris, PARIS, Parisse',
      acceptedAnswersTip: 'Séparez les différentes orthographes acceptées par des virgules.',
      correctNumber: 'Bonne réponse (nombre exact)',
      correctStars: 'Bonne réponse (nombre d\'étoiles)',
      questionDuration: 'Durée de la question',
      questionDuplicated: 'Question dupliquée',
      maxOptions: 'Maximum 6 options',
      minAnswers: 'Minimum 2 options requises',
      minQuestions: 'Le quiz doit avoir au moins une question',
      titleRequired: 'Veuillez entrer un titre pour le quiz',
      questionTextRequired: 'Veuillez entrer le texte de la question',
      minOptionsRequired: 'Au moins 2 options sont requises',
      selectCorrect: 'Veuillez sélectionner au moins une bonne réponse',
      correctAnswerRequired: 'Veuillez entrer la bonne réponse',
      updateSuccess: 'Quiz mis à jour !',
      saveQuiz: 'Enregistrer le quiz',
      saving: 'Enregistrement...',
      saveSuccess: 'Quiz enregistré avec succès',
      saveError: 'Erreur lors de l\'enregistrement'
    },
    live: {
      title: 'Quiz Live',
      host: 'Animer',
      join: 'Rejoindre',
      waitingRoom: 'Salle d\'attente',
      waitingForHost: 'En attente de l\'animateur...',
      waitingForPlayers: 'En attente de joueurs...',
      startQuiz: 'Démarrer le quiz',
      playersReady: 'joueurs prêts',
      enterName: 'Entrez votre nom',
      enterNamePlaceholder: 'Votre pseudo',
      joinGame: 'Rejoindre la partie',
      shareLink: 'Partagez ce lien',
      shareCode: 'ou ce code',
      scanQR: 'Scannez le QR code',
      preparing: 'Préparation du quiz...',
      getReady: 'Préparez-vous !',
      questionOf: 'Question {{current}} sur {{total}}',
      showResults: 'Voir les résultats',
      showLeaderboard: 'Afficher le classement',
      showPodium: 'Afficher le podium',
      nextQuestionBtn: 'Question suivante',
      endQuiz: 'Terminer le quiz',
      stopQuiz: 'Arrêter le quiz',
      forceStop: 'Arrêt forcé',
      quizEnded: 'Quiz terminé !',
      thanks: 'Merci d\'avoir participé !',
      yourScore: 'Votre score',
      yourRank: 'Votre classement',
      backToHome: 'Retour à l\'accueil',
      noAnswer: 'Pas de réponse',
      answered: 'Répondu',
      waiting: 'En attente...',
      correctPlayers: 'bonnes réponses',
      avgTime: 'Temps moyen',
      fastestPlayer: 'Le plus rapide',
      you: 'vous',
      noScoresYet: 'Aucun score pour le moment',
      playersCount: '{{count}} joueur',
      playersCount_plural: '{{count}} joueurs',
      playersConnected: '{{count}} joueur connecté',
      playersConnected_plural: '{{count}} joueurs connectés',
      playingAs: 'Vous jouez en tant que',
      youAreFirst: 'Vous êtes le premier !',
      hostAboutToStart: "L'animateur va bientôt lancer le quiz",
      orderElements: 'Classez les éléments dans le bon ordre',
      validateOrder: 'Valider mon classement',
      answerCount: '{{count}} réponse',
      answerCount_plural: '{{count}} réponses',
      checkAllCorrect: 'Cochez toutes les bonnes réponses',
      validateAnswer: 'Valider ma réponse',
      typeYourAnswer: 'Tapez votre réponse...',
      enterNumber: 'Entrez un nombre...',
      validate: 'Valider',
      answerSent: 'Réponse envoyée !',
      waitingForTimeEnd: 'En attente de la fin du temps...',
      correctAnswerWas: 'La bonne réponse était',
      // New keys
      joinLiveQuiz: 'Rejoindre le quiz en direct',
      chooseAvatar: 'Choisissez votre avatar',
      randomEmoji: 'Emoji aléatoire',
      joinWaitingRoom: 'Rejoindre la salle d\'attente',
      hostMode: 'MODE ANIMATEUR',
      players: 'joueurs',
      revealAnswers: 'Révéler les réponses',
      answersReceived: 'réponses reçues',
      viewFinalScores: 'Voir les scores finaux',
      finalScores: 'SCORES FINAUX',
      yourFinalRanking: 'Votre classement final',
      sessionNotFound: 'Session de jeu introuvable',
      alreadyStarted: 'Ce quiz a déjà commencé',
      sessionClosed: 'La session a été fermée',
      welcome: 'Bienvenue dans le quiz !',
      joinError: 'Erreur lors de la connexion',
      notFound: 'Quiz introuvable',
      notOwner: 'Vous n\'êtes pas le propriétaire de ce quiz',
      noQuestions: 'Ce quiz n\'a pas de questions',
      loadError: 'Erreur lors du chargement du quiz',
      startError: 'Erreur lors du démarrage',
      nextQuestionError: 'Erreur lors du passage à la question suivante',
      confirmStop: 'Êtes-vous sûr de vouloir arrêter le quiz maintenant ?',
      correct: 'Correct !',
      incorrect: 'Incorrect',
      points: 'points',
      podium: {
        title: 'Le Podium',
        first: '1er',
        second: '2ème',
        third: '3ème',
        congratulations: 'Félicitations !',
        bestPlayers: 'Les meilleurs joueurs de ce quiz !'
      }
    }
  },
  
  // Questionnaire
  questionnaire: {
    title: 'Titre du questionnaire',
    description: 'Description',
    questions: 'Questions',
    question: 'Question',
    create: 'Créer un questionnaire',
    edit: 'Modifier le questionnaire',
    editDescription: 'Modifiez les questions et les conditions de branchement',
    generalInfo: 'Informations générales',
    descriptionOptional: 'Description (optionnel)',
    addQuestion: 'Ajouter une question',
    questionText: 'Texte de la question',
    responseType: 'Type de réponse',
    responseOptions: 'Options de réponse',
    addOption: 'Ajouter une option',
    placeholderLabel: 'Placeholder (texte d\'aide)',
    required: 'Question obligatoire',
    requiredShort: 'Obligatoire',
    conditional: 'Conditionnelle',
    conditionalBranching: 'Question conditionnelle (branchement)',
    defineWhereToGo: 'Définissez où aller selon la réponse :',
    ifAnswer: 'Si "{{answer}}" →',
    nextQuestionDefault: 'Question suivante (par défaut)',
    nextQuestion: 'Question suivante',
    byDefault: 'Par défaut →',
    endOfQuestionnaire: 'Fin du questionnaire',
    noText: 'Sans texte',
    questionWithoutText: 'Question sans texte',
    noQuestionsAdded: 'Aucune question ajoutée',
    addFirstQuestion: 'Ajouter la première question',
    notFound: 'Questionnaire introuvable',
    noQuestions: 'Ce questionnaire n\'a pas de questions',
    enterName: 'Veuillez entrer votre nom',
    startError: 'Erreur lors du démarrage',
    invalidEmail: 'Veuillez entrer un email valide',
    selectAtLeastOne: 'Veuillez sélectionner au moins une option',
    requiredQuestion: 'Cette question est obligatoire',
    play: {
      title: 'Questionnaire',
      description: 'Répondez aux questions ci-dessous',
      yourName: 'Votre nom',
      enterName: 'Entrez votre nom',
      start: 'Commencer',
      questionOf: 'Question {{current}} sur {{total}}',
      multipleAnswersPossible: 'Plusieurs réponses possibles',
      selectOption: 'Sélectionnez une option',
      yourAnswer: 'Votre réponse',
      yourDetailedAnswer: 'Votre réponse détaillée',
      enterNumber: 'Entrez un nombre',
      previous: 'Précédent',
      next: 'Suivant',
      finish: 'Terminer',
      thanks: 'Merci {{name}} !',
      responsesRecorded: 'Vos réponses ont été enregistrées.',
      summary: 'Récapitulatif',
      questionsAnswered: '{{count}} question(s) répondue(s)',
      seeDetails: 'Voir les détails',
      backToHome: 'Retour à l\'accueil'
    },
    responses: 'Réponses',
    totalResponses: 'réponses reçues',
    noResponses: 'Aucune réponse pour le moment',
    anonymous: 'Réponse anonyme',
    optional: 'Question optionnelle',
    conditionalLogic: 'Logique conditionnelle',
    addCondition: 'Ajouter une condition',
    thenGoTo: 'Alors aller à',
    questionTypes: {
      singleChoice: 'Choix unique',
      multipleChoice: 'Plusieurs réponses',
      trueFalse: 'Vrai ou Faux',
      dropdown: 'Liste déroulante',
      shortText: 'Réponse texte',
      longText: 'Texte long',
      number: 'Réponse numérique',
      email: 'Email',
      date: 'Date',
      rating: 'Évaluation',
      yesNo: 'Oui/Non',
      ordering: 'Classement'
    },
    placeholders: {
      title: 'Ex: Enquête de satisfaction',
      description: 'Décrivez brièvement votre questionnaire...',
      questionText: 'Entrez votre question...',
      option: 'Option',
      placeholder: 'Ex: Entrez votre réponse...',
      shortText: 'Votre réponse...',
      longText: 'Écrivez votre réponse détaillée...',
      number: 'Entrez un nombre',
      email: 'votre@email.com',
      date: 'Sélectionnez une date'
    },
    submit: 'Soumettre',
    submitSuccess: 'Merci pour votre réponse !',
    submitError: 'Erreur lors de l\'envoi',
    results: {
      title: 'Résultats',
      summary: 'Résumé',
      details: 'Détails',
      export: 'Exporter',
      filter: 'Filtrer',
      respondent: 'Répondant',
      date: 'Date',
      viewResponse: 'Voir la réponse'
    },
    playScreen: {
      title: 'Questionnaire',
      description: 'Description',
      yourName: 'Votre nom',
      enterName: 'Entrez votre nom',
      start: 'Commencer',
      questionOf: 'Question {current} sur {total}',
      multipleAnswersPossible: 'Plusieurs réponses possibles',
      selectOption: 'Sélectionnez une option',
      yourAnswer: 'Votre réponse',
      yourDetailedAnswer: 'Votre réponse détaillée',
      enterNumber: 'Entrez un nombre',
      previous: 'Précédent',
      next: 'Suivant',
      finish: 'Terminer',
      thanks: 'Merci !',
      responsesRecorded: 'Vos réponses ont été enregistrées.',
      summary: 'Récapitulatif',
      questionsAnswered: 'Questions répondues',
      seeDetails: 'Voir les détails',
      backToHome: 'Retour à l\'accueil'
    }
  },
  
  // Events / Gifts
  events: {
    event: 'Événement',
    ourEvent: 'notre événement',
    title: "Titre de l'événement",
    date: 'Date',
    location: 'Lieu',
    guests: 'Invités',
    guest: 'Invité',
    tables: 'Tables',
    table: 'Table',
    seatingPlan: 'Plan de salle',
    guestbook: "Livre d'or",
    giftList: 'Liste de cadeaux',
    scanner: 'Scanner QR',
    present: 'Présent',
    absent: 'Absent',
    confirmed: 'Confirmé',
    notConfirmed: 'Non confirmé',
    addGuest: 'Ajouter un invité',
    editGuest: 'Modifier l\'invité',
    deleteGuest: 'Supprimer l\'invité',
    exportExcel: 'Export Excel',
    totalGuests: 'Total invités',
    couple: 'Couple',
    single: 'Célibataire',
    family: 'Famille',
    relation: 'Relation',
    capacity: 'Capacité',
    create: {
      title: 'Créer un événement',
      subtitle: 'Configurez votre événement et sa liste de cadeaux',
      editTitle: 'Modifier l\'événement',
      eventName: 'Nom de l\'événement',
      eventNamePlaceholder: 'Ex: Mariage de Sophie et Thomas',
      eventNameRequired: 'Le nom de l\'événement est requis',
      eventDate: 'Date de l\'événement',
      eventLocation: 'Lieu',
      eventLocationPlaceholder: 'Ex: Château de Versailles',
      eventDescription: 'Description',
      eventDescriptionPlaceholder: 'Décrivez votre événement...',
      eventType: 'Type d\'événement',
      enableGiftList: 'Activer la liste de cadeaux',
      enableGuestbook: 'Activer le livre d\'or',
      enableSeating: 'Activer le plan de salle',
      saveEvent: 'Enregistrer l\'événement',
      other: 'Autre',
      basicInfo: 'Informations de base',
      basicInfoDesc: 'Nom, type, date et description',
      shortDescription: 'Description courte',
      shortDescriptionPlaceholder: 'Une brève description de votre événement...',
      coverImage: 'Image de couverture',
      publicEvent: 'Événement public',
      privateEvent: 'Événement privé',
      accessibleWithLink: 'Accessible avec le lien',
      restrictedAccess: 'Accès restreint',
      publicEventWithLink: 'Événement public (accessible à tous avec le lien)',
      eventStory: 'Histoire de l\'événement',
      eventStoryDesc: 'Racontez votre histoire aux invités',
      storyHelpText: 'Partagez l\'histoire de votre événement. Par exemple, pour un mariage, racontez comment vous vous êtes rencontrés. Cette histoire sera affichée à vos invités après leur inscription.',
      storyPlaceholder: 'Il était une fois...',
      invitationTicket: 'Billet d\'invitation',
      invitationTicketDesc: 'Image et lettre personnalisée en PDF',
      howItWorks: 'Comment ça marche',
      invitationExplanation: 'Vos invités pourront télécharger un PDF personnalisé contenant votre image d\'invitation + une lettre avec leur nom.',
      invitationImage: 'Image d\'invitation (Page 1 du PDF)',
      invitationLetter: 'Lettre d\'invitation (Page 2 du PDF)',
      invitationLetterHint: 'Le PDF commencera par "Très cher(e) [Nom de l\'invité]," suivi de votre texte.',
      invitationLetterPlaceholder: 'Nous avons le plaisir de vous convier à notre mariage qui se tiendra le...',
      photoGallery: 'Galerie photos',
      photoGalleryDesc: 'Montage photo automatique pour vos invités',
      galleryHelpText: 'Ajoutez jusqu\'à 10 photos. Un collage automatique sera créé et affiché à vos invités pour les immerger dans l\'ambiance de votre événement.',
      collagePreview: 'Aperçu du collage',
      managePhotos: 'Gérer les photos',
      createEvent: 'Créer l\'événement',
      creating: 'Création...',
      permissionDenied: 'Accès refusé. Votre compte doit être validé par un administrateur.',
      errorCreating: 'Erreur lors de la création: {{message}}',
      howItWorksTitle: 'Comment ça fonctionne pour vos invités',
      step1: 'Ils entrent leur nom complet',
      step2: 'Ils découvrent votre histoire et peuvent télécharger leur invitation personnalisée',
      step3: 'Ils accèdent à la liste de cadeaux pour réserver',
      showInvitationTicket: 'Afficher le billet d\'invitation',
      showInvitationTicketDesc: 'Les invités pourront voir et télécharger le billet sur la page de l\'événement',
      hideInvitationTicket: 'Masquer le billet d\'invitation',
      hideInvitationTicketDesc: 'Le billet ne sera pas visible par les invités',
      backgroundMusic: 'Musique de fond',
      backgroundMusicDesc: 'Musique jouée en boucle sur la page des photos et de l\'histoire',
      uploadMusic: 'Uploader une musique',
      musicFormats: 'Formats acceptés: MP3, M4A, WAV, OGG (max 10 Mo)',
      removeMusic: 'Supprimer la musique',
      musicPlaying: 'Musique en cours de lecture',
      musicPaused: 'Musique en pause'
    },
    edit: {
      notFound: 'Événement non trouvé',
      notAuthorized: 'Vous n\'êtes pas autorisé à modifier cet événement',
      loadError: 'Erreur lors du chargement de l\'événement',
      updateSuccess: 'Événement mis à jour avec succès',
      saveError: 'Erreur lors de la sauvegarde',
      deleteError: 'Erreur lors de la suppression',
      reservationDeleted: 'Réservation supprimée',
      reservationDeleteError: 'Erreur lors de la suppression de la réservation',
      linkCopied: 'Lien copié !',
      eventDetails: 'Détails de l\'événement',
      ourStory: 'Notre histoire',
      configured: 'Configuré',
      storyDesc: 'Racontez votre histoire ! Les visiteurs la verront avant d\'accéder à la liste de cadeaux.',
      storyPlaceholder: 'Comment vous êtes-vous rencontrés ? Racontez les moments forts de votre histoire...',
      personalizedInvitation: 'Invitation personnalisée',
      invitationDesc: 'Créez une invitation PDF personnalisée que vos invités pourront télécharger avec leur nom.',
      invitationImagePage1: 'Image d\'invitation (page 1 du PDF)',
      formatRecommendation: 'Format recommandé: A4 portrait (210x297mm)',
      letterTextPage2: 'Texte de la lettre (page 2 du PDF)',
      letterPlaceholder: 'Cher(e) invité(e),\n\nNous avons l\'immense joie de vous convier à notre mariage...',
      guestNameAutoAdded: 'Le nom de l\'invité sera automatiquement ajouté en haut de la lettre',
      galleryDesc: 'Ajoutez jusqu\'à 10 photos pour un collage automatique que les visiteurs verront.',
      saving: 'Sauvegarde...',
      saveAllChanges: 'Sauvegarder toutes les modifications',
      managePrograms: 'Gérer les programmes & menus',
      reservation: 'réservation',
      reservation_plural: 'réservations',
      deleteEventConfirmTitle: 'Supprimer l\'événement ?',
      deleteEventConfirmMessage: 'Cette action supprimera également tous les cadeaux et réservations associés. Cette action est irréversible.',
      deleteReservationConfirmTitle: 'Supprimer cette réservation ?',
      deleteReservationConfirmMessage: 'Voulez-vous vraiment supprimer la réservation de {{name}} ?'
    },
    view: {
      event: 'Événement',
      notFound: 'Événement non trouvé',
      loadError: 'Erreur lors du chargement de l\'événement',
      loadingEvent: 'Chargement de l\'événement...',
      oops: 'Oups !',
      backToHome: 'Retour à l\'accueil',
      welcome: 'Bienvenue !',
      welcomeName: 'Bienvenue {{name}} !',
      enterNameToAccess: 'Entrez votre nom pour accéder à l\'événement',
      registerToAccess: 'Inscrivez-vous pour accéder à l\'événement et à la liste de cadeaux',
      yourFullName: 'Votre nom complet',
      enterFullName: 'Veuillez entrer votre nom complet',
      fillNameRequired: 'Veuillez remplir le nom et le prénom',
      selectRelation: 'Veuillez sélectionner votre relation avec l\'organisateur',
      fillSpouseRequired: 'Veuillez remplir les informations du/de la conjoint(e)',
      registrationError: 'Erreur lors de l\'inscription',
      registrationNote: 'Votre inscription sera validée par l\'organisateur avant d\'être ajoutée à la liste des invités.',
      firstName: 'Prénom',
      lastName: 'Nom',
      firstNamePlaceholder: 'Votre prénom',
      lastNamePlaceholder: 'Votre nom',
      gender: 'Genre',
      male: 'Homme',
      female: 'Femme',
      relationWithOrganizer: 'Relation avec l\'organisateur',
      invitationType: 'Type d\'invitation',
      singleInvitation: 'Invitation Solo',
      coupleInvitation: 'Invitation Couple',
      spouseInfo: 'Informations du/de la conjoint(e)',
      spouseFirstName: 'Prénom du/de la conjoint(e)',
      spouseLastName: 'Nom du/de la conjoint(e)',
      spouseGender: 'Genre du/de la conjoint(e)',
      toTheEvent: 'à l\'événement',
      ourStory: 'Notre histoire',
      yourPersonalizedInvitation: 'Votre invitation personnalisée',
      downloadPdfWithName: 'Téléchargez votre invitation PDF avec votre nom',
      generating: 'Génération...',
      downloadAgain: 'Télécharger à nouveau',
      downloadMyInvitation: 'Télécharger mon invitation',
      invitationDownloadedSuccess: 'Invitation téléchargée avec succès !',
      pdfDownloaded: '🎉 Votre invitation personnalisée a été téléchargée !',
      pdfError: 'Erreur lors de la génération du PDF',
      discoverGiftList: 'Découvrir la liste de cadeaux',
      chooseGiftToOffer: 'Choisissez le cadeau que vous souhaitez offrir',
      listEmpty: 'La liste est vide pour le moment',
      noGiftsYet: 'L\'organisateur n\'a pas encore ajouté de cadeaux.',
      on: 'sur',
      reserveThisGift: 'Réserver ce cadeau',
      yourName: 'Votre nom',
      enterYourName: 'Veuillez entrer votre nom',
      stayAnonymous: 'Rester anonyme',
      onlyOrganizerSees: 'Seuls vous et l\'organisateur verrez votre nom ; les autres verront « anonyme »',
      you: 'vous',
      anonymousSelfNote: 'Seuls vous et l\'organisateur voyez votre nom. Les autres voient « anonyme ».',
      howManyReserve: 'Combien souhaitez-vous en réserver ?',
      outOf: 'sur',
      available: 'disponible(s)',
      messageOptional: 'Message (optionnel)',
      messagePlaceholder: 'Un petit mot pour les organisateurs... 💝',
      visibleToOrganizerOnly: 'Visible uniquement par l\'organisateur',
      reserving: 'Réservation...',
      onlyRemainingReservations: 'Il ne reste que {{count}} réservation(s) disponible(s)',
      reservationSuccess: 'Merci {{name}} ! 🎉 Votre réservation a été enregistrée.',
      reservationError: 'Erreur lors de la réservation',
      linkCopied: '✨ Lien copié dans le presse-papier !',
      iOfferIt: 'Je l\'offre !',
      ourGallery: 'Notre Galerie',
      photosAutoScroll: '{{count}} photo(s) • Défilement auto',
      photoOf: 'Photo {{current}} / {{total}}'
    },
    gifts: {
      title: 'Liste de cadeaux',
      gifts: 'Cadeaux',
      gift: 'cadeau',
      gift_plural: 'cadeaux',
      addGift: 'Ajouter un cadeau',
      editGift: 'Modifier le cadeau',
      giftName: 'Nom du cadeau',
      giftNamePlaceholder: 'Ex: Robot de cuisine',
      giftNameRequired: 'Le nom du cadeau est requis',
      giftPrice: 'Prix (€)',
      giftDescription: 'Description',
      giftImage: 'Image',
      giftLink: 'Lien externe',
      available: 'Disponible',
      reserved: 'Réservé',
      purchased: 'Acheté',
      reserveGift: 'Réserver ce cadeau',
      cancelReservation: 'Annuler la réservation',
      reservedBy: 'Réservé par',
      participateAmount: 'Participer (montant libre)',
      totalCollected: 'Total collecté',
      contributions: 'contributions',
      noGifts: 'Aucun cadeau dans la liste',
      addFirst: 'Ajoutez des cadeaux pour commencer',
      giftUpdated: 'Cadeau mis à jour',
      giftAdded: 'Cadeau ajouté',
      giftDeleted: 'Cadeau supprimé',
      giftSaveError: 'Erreur lors de l\'enregistrement du cadeau',
      deleteGiftConfirm: 'Supprimer ce cadeau ?',
      notesVisibleToGuests: 'Notes (visibles par les invités)',
      notesPlaceholder: 'Ex: Couleur préférée: rouge',
      allowMultipleReservations: 'Permettre plusieurs réservations',
      giftType: 'Type de cadeau',
      typeArticle: 'Article',
      typeArticleDesc: 'Un article classique à offrir',
      typeMoney: 'Argent',
      typeMoneyDesc: 'Contribution financière libre',
      typeShared: 'Article partagé',
      typeSharedDesc: 'Article dont le prix est partagé entre plusieurs invités',
      targetAmount: 'Montant cible (€)',
      targetAmountPlaceholder: 'Ex: 500',
      yourContribution: 'Votre contribution (€)',
      contributionPlaceholder: 'Entrez un montant',
      amountRequired: 'Veuillez entrer un montant',
      amountTooHigh: 'Le montant dépasse le reste à collecter ({{remaining}}€)',
      contributionSuccess: 'Merci {{name}} ! 🎉 Votre contribution de {{amount}}€ a été enregistrée.',
      contributionUpdated: 'Votre contribution a été mise à jour.',
      yourPreviousContribution: 'Votre contribution précédente',
      updateContribution: 'Modifier ma contribution',
      remainingAmount: 'Reste à collecter',
      goalReached: 'Objectif atteint ! 🎉',
      goalReachedDesc: 'Le montant cible a été atteint',
      progressLabel: 'Progression',
      contributorsCount: '{{count}} contributeur(s)',
      enterValidAmount: 'Veuillez entrer un montant valide',
      moneyGiftName: 'Contribution financière',
      moneyGiftDesc: 'Les invités contribuent le montant de leur choix',
      privateContribution: 'Votre contribution est privée et visible uniquement par vous et l\'organisateur',
      sendMoney: 'Envoyer l\'argent',
      paymentLink: 'Lien de paiement (banque, PayPal, Lydia...)',
      paymentLinkDesc: 'Les invités pourront cliquer pour envoyer l\'argent directement',
      reservationsPossible: '{{count}} réservation(s) possible(s)',
      imageByUrl: 'Image par URL',
      imageByUrlPlaceholder: 'https://exemple.com/image.jpg',
      imageByUpload: 'Image par upload',
      orUseUrl: 'Ou coller une URL d\'image'
    },
    invitation: {
      title: 'Invitation',
      createPdf: 'Créer PDF',
      sendEmail: 'Envoyer par email',
      copyLink: 'Copier le lien',
      qrCode: 'QR Code',
      preview: 'Aperçu'
    }
  },
  
  // Guestbook
  guestbook: {
    title: "Livre d'or",
    theGuestbook: "Le Livre d'Or",
    leaveMessage: 'Laisser un message',
    leaveNote: 'Laissez un petit mot',
    leaveNoteDesc: 'Partagez vos vœux, une anecdote ou un souvenir photo pour célébrer ce moment avec nous.',
    leaveEternalMemory: 'Laissez un souvenir éternel',
    leaveEternalMemoryDesc: 'Immortalisez votre présence avec un message en 3D pour les mariés.',
    yourName: 'Votre nom',
    yourMessage: 'Votre message',
    writeMemorable: 'Écrivez quelque chose de mémorable...',
    characters: 'caractères',
    photoMemory: 'Photo Souvenir',
    photoFormats: 'JPG, PNG (max 5MB)',
    addPhoto: 'Ajouter une photo',
    send: 'Envoyer',
    sign: 'Signer',
    signBook: "Signer le Livre d'Or",
    signTheBook: 'Signez le livre',
    readBook: 'Lire le livre',
    messages: 'Messages',
    noMessages: 'Aucun message pour l\'instant',
    noMessagesYet: 'Aucun message encore...',
    beFirst: 'Soyez le premier à signer !',
    deleteMessage: 'Supprimer ce message',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce message ?',
    messageDeleted: 'Message supprimé',
    from: 'De :',
    withLove: '– Avec tout notre amour ❤️',
    memories: 'Souvenirs...',
    pageOf: 'PAGE {{current}} SUR {{total}}',
    latestMessages: 'Derniers messages',
    photoShared: '📷 Photo partagée',
    experience3d: 'Expérience 3D',
    howItWorks: 'Comment ça marche ?',
    takePhoto: 'Prenez une photo',
    writeWord: 'Écrivez un mot',
    imageTooLarge: 'Image trop grande (max 5 Mo)',
    invalidFile: 'Fichier non valide',
    enterName: 'Veuillez entrer votre nom',
    addMessageOrPhoto: 'Ajoutez un message ou une photo',
    messageAdded: 'Message ajouté ! 💕',
    sendError: 'Erreur lors de l\'envoi',
    minutesAgo: 'Il y a {{count}} min',
    hoursAgo: 'Il y a {{count}}h',
    daysAgo: 'Il y a {{count}}j',
    noMessagesToExport: 'Aucun message à exporter',
    generatingPdf: 'Génération du PDF...',
    generatedOn: 'Généré le',
    messagesCount: 'message(s)',
    pdfDownloaded: 'PDF téléchargé !',
    pdfError: 'Erreur lors de la génération du PDF',
    shareLink: 'Partager le lien',
    downloadPdf: 'Télécharger le PDF',
    linkShared: 'Lien partagé !',
    linkCopied: 'Lien copié dans le presse-papier !',
    copyError: 'Impossible de copier le lien',
    shareText: 'Laissez un message dans le livre d\'or de {{eventName}} ! 💌',
    anonymous: 'Anonyme',
    messagesPublic: 'Messages visibles par tous',
    messagesPrivate: 'Messages visibles par vous seul',
    messagesPublicDesc: 'Les invités peuvent lire les messages des autres',
    messagesPrivateDesc: 'Les invités peuvent uniquement écrire, seul vous pouvez lire'
  },

  // Guests
  guests: {
    title: 'Liste des Invités',
    addGuest: 'Ajouter un Invité',
    editGuest: 'Modifier l\'Invité',
    firstName: 'Prénom',
    lastName: 'Nom',
    gender: 'Genre',
    male: 'Homme',
    female: 'Femme',
    ticketType: 'Type de billet',
    single: 'Single',
    couple: 'Couple',
    spouseInfo: 'Informations du/de la conjoint(e)',
    relation: 'Relation avec l\'organisateur',
    selectRelation: '-- Sélectionner --',
    table: 'Table',
    tableOptional: 'Table (optionnel)',
    notAssigned: '-- Non assigné --',
    cancel: 'Annuler',
    addTheGuest: 'Ajouter l\'invité',
    saveChanges: 'Enregistrer',
    totalGuests: 'Total Invités',
    tickets: 'Billets',
    present: 'Présent',
    absent: 'Absent',
    presents: 'Présents',
    absents: 'Absents',
    searchGuest: 'Rechercher un invité...',
    allStatuses: 'Tous les statuts',
    allTickets: 'Tous les billets',
    noGuests: 'Aucun invité pour le moment',
    noMatchingGuests: 'Aucun invité ne correspond à votre recherche',
    addFirstGuest: 'Ajouter le premier invité',
    guest: 'Invité',
    type: 'Type',
    statusClick: 'Statut (cliquez pour changer)',
    actions: 'Actions',
    downloadPdf: 'Télécharger PDF',
    edit: 'Modifier',
    deleteGuest: 'Supprimer',
    yourInvitation: 'Votre Billet d\'Invitation',
    coupleTicket: 'Billet Couple avec',
    scanQrCode: 'Scannez ce QR code à l\'entrée',
    personalTicket: 'Ce billet est personnel et non transférable',
    sortNameAsc: 'Nom (A → Z)',
    sortNameDesc: 'Nom (Z → A)',
    sortFirstNameAsc: 'Prénom (A → Z)',
    sortFirstNameDesc: 'Prénom (Z → A)',
    sortDateRecent: 'Plus récent',
    sortDateOldest: 'Plus ancien',
    sortByTable: 'Par table',
    sortByRelation: 'Par relation',
    sortPresentFirst: 'Présents d\'abord',
    sortAbsentFirst: 'Absents d\'abord',
    tables: 'Tables',
    scanner: 'Scanner',
    plan: 'Plan',
    guestbook: 'Livre d\'or',
    excel: 'Excel',
    add: 'Ajouter',
    // Excel export fields
    number: 'N°',
    arrivalDate: 'Date arrivée',
    registrationDate: 'Date inscription',
    spouseFirstName: 'Prénom conjoint',
    spouseLastName: 'Nom conjoint',
    spouseGender: 'Genre conjoint',
    spouseStatus: 'Statut conjoint',
    spouseArrival: 'Arrivée conjoint',
    // Summary sheet
    statistic: 'Statistique',
    value: 'Valeur',
    summary: 'Résumé',
    totalInvitations: 'Total invitations',
    totalPersons: 'Total personnes',
    guestsPresent: 'Invités présents',
    guestsAbsent: 'Invités absents',
    couples: 'Couples',
    singles: 'Singles',
    spousesPresent: 'Conjoints présents',
    exportDate: 'Date export',
    // Pending guests
    pendingApproval: 'En attente',
    pendingRequests: 'Demandes en attente',
    confirmedList: 'Liste confirmée',
    noPendingRequests: 'Aucune demande en attente',
    noPendingDescription: 'Les invités qui s\'inscrivent via le lien de l\'événement apparaîtront ici pour validation.',
    pendingInfo: 'Ces personnes se sont inscrites via le lien de l\'événement et attendent votre validation.',
    requestedOn: 'Demande le',
    approve: 'Approuver',
    reject: 'Refuser',
    pendingApproved: 'Invité approuvé et ajouté à la liste',
    pendingRejected: 'Demande refusée',
    approveError: 'Erreur lors de l\'approbation',
    rejectError: 'Erreur lors du rejet'
  },

  // Relations
  relations: {
    fatherGroom: 'Père du marié',
    motherGroom: 'Mère du marié',
    brotherGroom: 'Frère du marié',
    sisterGroom: 'Sœur du marié',
    fatherBride: 'Père de la mariée',
    motherBride: 'Mère de la mariée',
    brotherBride: 'Frère de la mariée',
    sisterBride: 'Sœur de la mariée',
    grandparent: 'Grand-parent',
    uncle: 'Oncle',
    aunt: 'Tante',
    cousin: 'Cousin(e)',
    nephew: 'Neveu/Nièce',
    childhoodFriend: 'Ami(e) d\'enfance',
    closeFriend: 'Ami(e) proche',
    colleague: 'Collègue',
    neighbor: 'Voisin(e)',
    witness: 'Témoin',
    bridesmaid: 'Demoiselle d\'honneur',
    groomsman: 'Garçon d\'honneur',
    otherFamily: 'Autre famille',
    otherFriend: 'Autre ami',
    professional: 'Professionnel',
    other: 'Autre'
  },

  // Event Types
  eventTypes: {
    wedding: 'Mariage',
    birthday: 'Anniversaire',
    birth: 'Naissance',
    baptism: 'Baptême',
    housewarming: 'Crémaillère',
    christmas: 'Noël',
    other: 'Événement'
  },

  // Event Responses / Statistics
  eventResponses: {
    title: 'Statistiques',
    backToDashboard: 'Retour au tableau de bord',
    stats: {
      giftsReserved: 'Cadeaux réservés',
      participants: 'Participants',
      reservations: 'Réservations',
      reservedValue: 'Valeur réservée'
    },
    progress: 'Progression',
    reservationsList: 'Liste des réservations',
    giftSummary: 'Récapitulatif par cadeau',
    anonymous: 'anonyme',
    giftDeleted: 'Cadeau supprimé',
    deleteReservation: 'Supprimer la réservation',
    noReservations: 'Aucune réservation pour le moment',
    shareToReceive: 'Partagez votre liste pour recevoir des réservations',
    reservation: 'réservation',
    notReserved: 'Non réservé',
    reserved: 'Réservé',
    available: 'Disponible',
    confirmDelete: 'Supprimer cette réservation ?',
    deleteSuccess: 'Réservation supprimée',
    errors: {
      notFound: 'Événement non trouvé',
      unauthorized: 'Vous n\'êtes pas autorisé à voir ces statistiques',
      loadError: 'Erreur lors du chargement des données',
      deleteError: 'Erreur lors de la suppression'
    }
  },

  // Profile
  profile: {
    title: 'Mon Profil',
    subtitle: 'Gérez vos informations personnelles',
    personalInfo: 'Informations personnelles',
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    bio: 'Biographie',
    bioPlaceholder: 'Parlez-nous de vous...',
    address: 'Adresse',
    streetName: 'Rue',
    streetNumber: 'N°',
    postalCode: 'Code postal',
    city: 'Ville',
    country: 'Pays',
    photoUpdated: 'Photo de profil mise à jour',
    photoError: 'Erreur lors du téléchargement de la photo',
    photoDeleted: 'Photo de profil supprimée',
    deletePhoto: 'Supprimer',
    deletePhotoError: 'Erreur lors de la suppression',
    invalidImageType: 'Veuillez sélectionner une image',
    imageTooLarge: 'L\'image ne doit pas dépasser 5MB',
    updated: 'Profil mis à jour avec succès',
    updateError: 'Erreur lors de la mise à jour',
    upgradeToPro: 'Passez au forfait Pro',
    managePlan: 'Gérer mon abonnement',
    unlockFeatures: 'Débloquez toutes les fonctionnalités et les participants illimités',
    currentPlan: 'Votre forfait actuel : {{plan}}',
    renewsIn: 'Renouvellement dans {{days}} jours',
    endsIn: 'Se termine dans {{days}} jours',
    manageSubscription: 'Gérer / Résilier',
    seePlans: 'Voir les forfaits',
    changePlan: 'Changer',
    subscriptionSettings: 'Paramètres d\'abonnement',
    managePayments: 'Gérer paiements et facturation',
    viewPlans: 'Voir les forfaits',
    comparePlans: 'Comparer les offres disponibles',
    logoutDesc: 'Se déconnecter de votre compte',
    legalInfo: 'Informations légales',
    dangerZone: 'Zone de danger',
    deleteAccountWarning: 'La suppression de votre compte est irréversible. Toutes vos données seront définitivement supprimées.',
    deleteAccount: 'Supprimer mon compte',
    confirmDeletion: 'Confirmer la suppression',
    actionIrreversible: 'Cette action est irréversible',
    importantNotice: 'Avertissement important',
    deleteWarning1: 'Tous vos quiz, questionnaires et événements seront supprimés',
    deleteWarning2: 'Vos données personnelles seront effacées définitivement',
    deleteWarning3: 'Vous ne pourrez plus accéder à votre compte',
    deleteWarning4: 'Si votre abonnement est renouvelé dans moins de 48h et que vous n\'avez pas annulé le renouvellement, le dernier prélèvement sera effectué avant la suppression.',
    typeConfirm: 'Tapez "SUPPRIMER" pour confirmer :',
    typeSupprimer: 'Veuillez taper "SUPPRIMER" pour confirmer',
    accountMarkedDeleted: 'Compte marqué pour suppression. Le dernier prélèvement sera effectué.',
    accountDeleted: 'Compte supprimé avec succès',
    deleteError: 'Erreur lors de la suppression',
    confirmDelete: 'Supprimer définitivement',
    adminGrantedAccess: 'Accès offert par l\'administrateur',
    adminGrantedAccessDesc: 'Vous bénéficiez d\'un accès complet offert par l\'administrateur.',
    revokeAccess: 'Renoncer à cet accès',
    revokeAccessConfirm: 'Renoncer à mon accès',
    revokeAccessDesc: 'Cette action supprimera votre accès offert. Vous reviendrez au forfait gratuit.'
  },
  
  // Settings
  settings: {
    title: 'Paramètres du compte',
    description: 'Gérez vos informations personnelles et vos paramètres',
    profile: 'Profil',
    language: 'Langue',
    theme: 'Thème',
    notifications: 'Notifications',
    security: 'Sécurité',
    changePassword: 'Changer le mot de passe',
    deleteAccount: 'Supprimer le compte',
    currentInfo: 'Informations actuelles',
    displayName: "Nom d'affichage",
    currentEmail: 'Email actuel',
    notDefined: 'Non défini',
    preferences: 'Préférences',
    tutorial: 'Tutoriel',
    restartTutorial: 'Relancer le tutoriel',
    darkMode: 'Mode sombre',
    lightMode: 'Mode clair',
    systemDefault: 'Système',
    saveChanges: 'Enregistrer les modifications',
    accountDanger: 'Zone de danger',
    deleteAccountWarning: 'Cette action est irréversible. Toutes vos données seront supprimées.',
    deleteAccountConfirm: 'Êtes-vous sûr de vouloir supprimer votre compte ?',
    email: {
      changeEmail: "Modifier l'email",
      newEmail: 'Nouvel email',
      confirmNewEmail: 'Confirmer le nouvel email',
      currentPassword: 'Mot de passe actuel (pour confirmer)',
      passwordHelp: 'Entrez votre mot de passe actuel pour confirmer la modification',
      updateEmail: "Mettre à jour l'email",
      updating: 'Mise à jour en cours...',
      fillAllFields: 'Veuillez remplir tous les champs',
      emailsMismatch: 'Les emails ne correspondent pas',
      sameEmail: "Le nouvel email est identique à l'actuel",
      invalidFormat: "Format d'email invalide",
      verificationSent: '📧 Un email de vérification a été envoyé à {{email}}. Cliquez sur le lien pour confirmer le changement.',
      verificationSentTitle: 'Email de vérification envoyé !',
      verificationSentDesc: 'Vérifiez votre boîte de réception et cliquez sur le lien pour confirmer',
      wrongPassword: 'Mot de passe incorrect',
      emailInUse: 'Cet email est déjà utilisé par un autre compte',
      sessionExpired: 'Session expirée. Veuillez vous reconnecter.',
      operationNotAllowed: 'Opération non autorisée. Vérifiez les paramètres Firebase.',
      updateError: 'Erreur lors de la mise à jour',
      howItWorks: 'Comment ça marche ?',
      step1: '1. Entrez votre nouvel email et votre mot de passe actuel',
      step2: '2. Un email de vérification sera envoyé à la nouvelle adresse',
      step3: "3. Cliquez sur le lien dans l'email pour confirmer le changement",
      important: 'Important',
      importantDesc: "La modification de votre email changera l'identifiant que vous utilisez pour vous connecter. Vous devrez utiliser le nouvel email lors de votre prochaine connexion."
    }
  },
  
  // Admin
  admin: {
    title: 'Administration',
    users: 'Utilisateurs',
    userManagement: 'Gestion des utilisateurs',
    pendingUsers: 'Utilisateurs en attente',
    validatedUsers: 'Utilisateurs validés',
    allUsers: 'Tous les utilisateurs',
    validateUser: 'Valider l\'utilisateur',
    rejectUser: 'Rejeter l\'utilisateur',
    makeAdmin: 'Promouvoir admin',
    removeAdmin: 'Retirer admin',
    deleteUser: 'Supprimer l\'utilisateur',
    userValidated: 'Utilisateur validé',
    userRejected: 'Utilisateur rejeté',
    tabs: {
      overview: 'Vue d\'ensemble',
      content: 'Contenu',
      activity: 'Activité',
      settings: 'Paramètres',
      storage: 'Stockage',
      services: 'Services',
      messaging: 'Messagerie'
    },
    messaging: {
      title: 'Envoyer un message',
      subtitle: "Écrivez à un, plusieurs ou tous les utilisateurs. Le message arrive par e-mail et notification.",
      allUsers: 'Tous les utilisateurs',
      selectUsers: 'Sélectionner des utilisateurs',
      searchUser: 'Rechercher un utilisateur...',
      toggleAll: 'Tout (dé)sélectionner',
      noUsers: 'Aucun utilisateur',
      subject: 'Objet',
      subjectPlaceholder: 'Objet de votre message',
      message: 'Message',
      messagePlaceholder: 'Écrivez votre message ici...',
      emailHint: "L'e-mail sera mis en forme avec le design HugoQuiz et un bouton vers le site.",
      send: 'Envoyer le message',
      sending: 'Envoi en cours...',
      needSubject: 'Veuillez saisir un objet.',
      needMessage: 'Veuillez saisir un message.',
      needRecipients: 'Sélectionnez au moins un destinataire.',
      confirm: 'Envoyer ce message à {{count}} utilisateur(s) ?',
      sent: 'Message envoyé à {{sent}}/{{total}} utilisateur(s).'
    },
    services: {
      verifications: 'Vérifications',
      servicesList: 'Services',
      reviews: 'Avis',
      noReviews: 'Aucun avis en attente de validation.',
      reviewApproved: 'Avis publié',
      reviewRejected: 'Avis rejeté',
      noVerifications: 'Aucune demande de vérification en attente.',
      noServices: 'Aucun service.',
      idDocument: 'Pièce d\'identité',
      openPdf: 'Ouvrir le PDF',
      selfieVideo: 'Vidéo selfie',
      approve: 'Valider',
      reject: 'Rejeter',
      publish: 'Publier',
      restrict: 'Restreindre',
      preview: 'Voir',
      verifApproved: 'Identité validée',
      verifRejected: 'Demande rejetée',
      serviceApproved: 'Service publié',
      serviceUpdated: 'Service mis à jour',
      serviceDeleted: 'Service supprimé',
      messagePlaceholder: 'Message expliquant la raison (envoyé à l\'utilisateur)',
      statusPending: 'En attente',
      statusApproved: 'Publié',
      statusRejected: 'Rejeté',
      statusRestricted: 'Restreint',
      seedHint: 'Créez deux services de démonstration (Hugographie — photographe/vidéaste, et Hugo — event-planner) rattachés à votre compte admin.',
      seedButton: 'Créer les services de démo',
      seedConfirm: 'Créer les services de démonstration Hugographie et Hugo sur votre compte admin ?',
      seedDone: 'Services de démonstration créés et publiés !',
      rejectVerifTitle: 'Rejeter la demande de vérification',
      rejectServiceTitle: 'Rejeter ce service',
      restrictTitle: 'Restreindre l\'affichage de ce service',
      deleteTitle: 'Supprimer définitivement ce service',
      filter: { all: 'Tous', pending: 'En attente', approved: 'Publiés', rejected: 'Rejetés', restricted: 'Restreints' }
    },
    storage: {
      title: 'Gestion du stockage',
      description: 'Surveillez et gérez l\'espace de stockage de chaque utilisateur',
      searchUser: 'Rechercher un utilisateur...',
      totalUsers: 'Utilisateurs',
      usageOk: 'Utilisation OK',
      nearLimit: 'Proche limite',
      exceeded: 'Dépassé',
      loading: 'Chargement des données de stockage...',
      noData: 'Cliquez sur Rafraîchir pour charger les données',
      user: 'Utilisateur',
      usage: 'Utilisation',
      limit: 'Limite',
      status: 'Statut',
      actions: 'Actions',
      editLimit: 'Modifier la limite',
      recalculate: 'Recalculer le stockage',
      ok: 'OK',
      warning: 'Attention',
      critical: 'Critique'
    },
    quizMusic: {
      title: 'Musiques Quiz',
      description: 'Gérez les musiques jouées pendant les quiz',
      lobby: 'Musique d\'ambiance',
      lobbyDesc: 'Musiques jouées dans la salle d\'attente',
      effects: 'Effets sonores',
      effectsDesc: 'Compte à rebours, transitions, résultats',
      gameplay: 'Musiques de jeu',
      gameplayDesc: 'Musiques par durée de question',
      upload: 'Uploader',
      delete: 'Supprimer',
      play: 'Jouer',
      pause: 'Pause',
      noMusic: 'Aucune musique',
      addMusic: 'Ajouter une musique',
      categories: {
        lobby: 'Salle d\'attente',
        countdown: 'Compte à rebours',
        transition: 'Transition',
        results: 'Résultats',
        podium: 'Podium'
      }
    },
    chat: {
      title: 'Gestion du Chat',
      subtitle: 'Répondez aux utilisateurs en attente',
      description: 'Répondez aux utilisateurs qui ont besoin d\'aide humaine.',
      manage: 'Gérer les chats',
      waiting: 'En attente',
      active: 'Actifs',
      waitingTag: 'En attente',
      humanMode: 'Humain',
      noConversations: 'Aucune conversation',
      selectConversation: 'Sélectionnez une conversation',
      selectHint: 'Cliquez sur une conversation à gauche pour commencer',
      placeholder: 'Tapez votre réponse...',
      returnToBot: 'Rendre au bot',
      close: 'Clôturer',
      confirmClose: 'Voulez-vous vraiment clôturer cette conversation ?',
      confirmReturnToBot: 'Voulez-vous rendre la main au bot ?',
      conversationClosed: 'Conversation clôturée',
      returnedToBot: 'Conversation rendue au bot',
      botModeWarning: 'Cette conversation est actuellement gérée par le bot.',
      takeOver: 'Prendre la main'
    }
  },
  
  // Chatbot
  chatbot: {
    title: 'Assistant HugoQuiz',
    placeholder: 'Posez votre question...',
    greeting: 'Bonjour ! Comment puis-je vous aider ?',
    suggestions: [
      'Comment créer un quiz ?',
      "Comment ajouter des invités ?",
      'Comment fonctionne le QR code ?'
    ],
    talkToHuman: 'Parler à un membre de l\'équipe',
    waitingForTeam: 'En attente de l\'équipe...',
    teamResponding: 'Équipe HugoQuiz',
    online: 'En ligne',
    conversationEnded: 'Conversation terminée'
  },
  
  // Tutorial
  tutorial: {
    welcome: 'Bienvenue sur HugoQuiz !',
    welcomeDesc: 'Laissez-nous vous guider pour découvrir toutes les fonctionnalités.',
    start: 'Commencer le tutoriel',
    skip: 'Passer',
    next: 'Suivant',
    prev: 'Précédent',
    finish: 'Terminer',
    step: 'Étape',
    of: 'sur',
    steps: {
      dashboard: {
        title: 'Votre tableau de bord',
        content: 'Ici vous retrouvez tous vos quiz, questionnaires et événements.'
      },
      createQuiz: {
        title: 'Créer un quiz',
        content: 'Cliquez ici pour créer un nouveau quiz interactif avec des questions et un minuteur.'
      },
      createEvent: {
        title: 'Créer un événement',
        content: 'Gérez vos mariages, anniversaires et fêtes avec liste d\'invités, QR codes et plan de salle.'
      },
      settings: {
        title: 'Paramètres',
        content: 'Personnalisez votre profil, changez la langue et gérez vos préférences.'
      },
      chatbot: {
        title: 'Besoin d\'aide ?',
        content: 'Notre assistant intelligent est toujours là pour répondre à vos questions !'
      }
    }
  },
  
  // Keyboard shortcuts
  shortcuts: {
    title: 'Raccourcis clavier',
    show: 'Afficher les raccourcis',
    navigation: 'Navigation',
    actions: 'Actions',
    goHome: "Aller à l'accueil",
    goDashboard: 'Aller au tableau de bord',
    goSettings: 'Aller aux paramètres',
    newQuiz: 'Nouveau quiz',
    newEvent: 'Nouvel événement',
    search: 'Rechercher',
    help: 'Aide / Raccourcis'
  },
  
  // Errors
  errors: {
    general: 'Une erreur est survenue',
    notFound: 'Page non trouvée',
    unauthorized: 'Accès non autorisé',
    forbidden: 'Accès interdit',
    serverError: 'Erreur serveur',
    networkError: 'Erreur réseau',
    timeout: 'Délai d\'attente dépassé',
    tryAgain: 'Veuillez réessayer',
    contactSupport: 'Contactez le support si le problème persiste'
  },
  
  // Validation
  validation: {
    required: 'Ce champ est obligatoire',
    email: 'Email invalide',
    minLength: 'Minimum {{min}} caractères',
    maxLength: 'Maximum {{max}} caractères',
    passwordMatch: 'Les mots de passe ne correspondent pas',
    invalidFormat: 'Format invalide',
    tooShort: 'Trop court',
    tooLong: 'Trop long'
  },
  
  // Time
  time: {
    seconds: 'secondes',
    minutes: 'minutes',
    hours: 'heures',
    days: 'jours',
    ago: 'il y a',
    remaining: 'restant',
    justNow: 'À l\'instant',
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    tomorrow: 'Demain'
  },

  // Subscription & Pricing
  subscription: {
    title: 'Abonnement',
    mySubscription: 'Mon abonnement',
    choosePlan: 'Choisissez votre forfait',
    subtitle: 'Des outils puissants pour créer des quiz et événements interactifs',
    month: 'mois',
    year: 'an',
    monthly: 'Mensuel',
    yearly: 'Annuel',
    savePercent: 'Économisez {{percent}}%',
    currentPlan: 'Forfait actuel',
    popular: 'Populaire',
    bestValue: 'Meilleure valeur',
    select: 'Choisir ce forfait',
    upgrade: 'Passer au supérieur',
    downgrade: 'Rétrograder',
    manage: 'Gérer',
    
    // Plan names
    plans: {
      free: 'Gratuit',
      freeDesc: 'Pour découvrir la plateforme',
      quizQuestionnaire: 'Quiz & Questionnaires',
      quizQuestionnaireDesc: 'Pour les créateurs de contenu',
      events: 'Événements',
      eventsDesc: 'Pour les organisateurs d\'événements',
      complete: 'Complet',
      completeDesc: 'Accès à toutes les fonctionnalités',
      adminGranted: 'Accès offert',
      quizMonthly: 'Quiz & Questionnaire - Mensuel',
      eventsMonthly: 'Événement - Mensuel',
      completeMonthly: 'Complet - Mensuel',
      quizYearly: 'Quiz & Questionnaire - Annuel',
      eventsYearly: 'Événement - Annuel',
      completeYearly: 'Complet - Annuel'
    },

    // Admin granted access
    adminGranted: {
      title: 'Accès offert par l\'administrateur',
      description: 'Vous bénéficiez d\'un accès gratuit offert par un administrateur. Cet accès peut être révoqué à tout moment.',
      renounceTitle: 'Renoncer à cet accès',
      renounceDesc: 'Si vous n\'avez plus besoin de cet accès, vous pouvez y renoncer et revenir au forfait gratuit.',
      renounceBtn: 'Renoncer à mon accès'
    },

    // Features
    features: {
      quiz: 'Quiz interactifs',
      questionnaire: 'Questionnaires',
      events: 'Événements',
      participants: '{{count}} participants max',
      participantsUnlimited: 'Participants illimités',
      liveMode: 'Mode live',
      analytics: 'Statistiques détaillées',
      export: 'Export des données',
      support: 'Support prioritaire'
    },

    // Status
    status: {
      active: 'Actif',
      expiringSoon: 'Expire bientôt',
      expired: 'Expiré',
      free: 'Gratuit',
      cancelled: 'Annulé',
      past_due: 'Paiement en attente',
      payment_failed: 'Paiement échoué'
    },

    // Messages
    expiresIn: 'Expire dans {{days}} jours',
    expiringSoonWarning: 'Votre abonnement expire bientôt',
    expiringSoonDesc: 'Renouvelez pour conserver l\'accès à vos données.',
    expiredWarning: 'Votre abonnement a expiré',
    expiredDesc: 'Vos questionnaires et événements seront supprimés dans 30 jours si vous ne renouvelez pas.',
    paymentFailedWarning: 'Échec de paiement',
    paymentFailedDesc: 'Nous n\'avons pas pu traiter votre paiement. Veuillez mettre à jour vos informations de paiement pour conserver votre abonnement.',
    pastDueWarning: 'Paiement en attente - Période de grâce',
    pastDueDesc: 'Votre paiement a échoué mais vous bénéficiez d\'une période de grâce de 7 jours. Mettez à jour votre moyen de paiement pour éviter la suspension.',
    gracePeriodEnds: 'La période de grâce se termine dans {{days}} jours',
    updatePaymentMethod: 'Mettre à jour le paiement',
    paymentRecovered: 'Paiement réussi ! Votre abonnement est à nouveau actif.',
    upgradeToPro: 'Passer au forfait Pro',
    managePayment: 'Gérer le paiement',
    changePlan: 'Changer de forfait',
    cancelSubscription: 'Annuler l\'abonnement',
    
    // Checkout
    processing: 'Traitement en cours...',
    redirectingToStripe: 'Redirection vers Stripe...',
    successTitle: 'Paiement réussi ! 🎉',
    successMessage: 'Votre abonnement est maintenant actif. Profitez de toutes les fonctionnalités !',
    cancelTitle: 'Paiement annulé',
    cancelMessage: 'Vous pouvez réessayer quand vous voulez.',
    goToDashboard: 'Aller au tableau de bord',
    tryAgain: 'Réessayer',

    // Errors
    errorCreatingCheckout: 'Erreur lors de la création de la session de paiement',
    errorOpeningPortal: 'Erreur lors de l\'ouverture du portail de gestion',
    portalError: 'Erreur lors de l\'ouverture du portail',

    // Cancellation
    cancellation: {
      title: 'Annulation',
      willNotRenew: 'Votre abonnement ne sera pas renouvelé',
      activeUntil: 'Il reste actif jusqu\'à la fin de la période en cours.',
      reactivate: 'Réactiver le renouvellement',
      refundAvailable: 'Remboursement disponible',
      refundTimeLeft: 'Il vous reste {{minutes}} minutes pour demander un remboursement complet.',
      requestRefund: 'Demander un remboursement',
      cancelRenewal: 'Annuler le renouvellement',
      cancelRenewalDesc: 'Votre abonnement restera actif jusqu\'à la fin de la période. Aucun remboursement ne sera effectué.',
      cancelRenewalBtn: 'Ne pas renouveler',
      tooLate: 'Annulation non disponible',
      tooLateDesc: 'Vous êtes à moins de 48 heures du renouvellement ({{hours}}h restantes). Le prochain paiement sera effectué. Vous pourrez annuler après le renouvellement.',
      confirmRefund: 'Confirmer le remboursement',
      confirmCancel: 'Confirmer l\'annulation',
      terminateTitle: 'Résilier mon forfait',
      terminateDesc: 'La résiliation est immédiate : vous perdez aussitôt les avantages du forfait et aucun remboursement n\'est possible.',
      terminateBtn: 'Résilier immédiatement',
      terminateConfirmTitle: 'Résilier le forfait ?',
      terminateWarn1: 'La perte des avantages du forfait est immédiate.',
      terminateWarn2: 'Aucun remboursement n\'est possible, conformément aux conditions d\'utilisation.',
      terminateWarn3: 'Vous reviendrez immédiatement au forfait gratuit.',
      errorTerminate: 'Erreur lors de la résiliation'
    },
    
    // Guarantees
    guarantee: {
      cancel: 'Annulation à tout moment',
      secure: 'Paiement sécurisé',
      support: 'Support inclus'
    },
    
    // Subscription management
    manageExisting: 'Gérer mon abonnement existant ou résilier',
    perMonth: 'par mois',
    perYear: 'par an',
    save: 'Économisez',
    subscribe: 'S\'abonner',
    currentPlanBadge: 'Votre forfait actuel',
    unlimitedQuiz: 'Quiz illimités',
    noQuiz: 'Quiz non inclus',
    unlimitedQuestionnaire: 'Questionnaires illimités',
    noQuestionnaire: 'Questionnaires non inclus',
    unlimitedEvents: 'Événements illimités',
    noEvents: 'Événements non inclus',
    unlimitedParticipants: 'Participants illimités',
    startTrial: 'Essai gratuit 7 jours',
    trialNotEligible: 'Vous n\'êtes pas éligible à l\'essai gratuit',
    
    // Trial
    trial: {
      banner: 'Essai gratuit de 7 jours !',
      bannerDesc: 'Testez toutes les fonctionnalités sans engagement. Annulable à tout moment.',
      cardRequired: 'Carte bancaire requise',
      alreadyUsed: 'Vous avez déjà utilisé votre essai gratuit.',
      adminGranted: 'L\'essai gratuit n\'est pas disponible pour les comptes ayant bénéficié d\'un accès offert.',
      notEligible: 'Vous n\'êtes pas éligible à l\'essai gratuit.',
      modalTitle: 'Essai gratuit de 7 jours',
      benefit1: 'Accès complet à toutes les fonctionnalités pendant 7 jours',
      benefit2: 'Annulable à tout moment avant la fin de l\'essai',
      warning: 'Carte bancaire requise. Prélèvement automatique de {{price}}€/mois à J+8 si non résilié.',
      uniqueOffer: 'L\'essai gratuit n\'est disponible qu\'une seule fois par utilisateur, quel que soit le forfait choisi.',
      confirm: 'Démarrer l\'essai',
      active: 'Essai gratuit en cours',
      endsIn: 'Se termine dans {{days}} jours',
      endsToday: 'Se termine aujourd\'hui',
      chargeDate: 'Premier prélèvement prévu le {{date}}',
      endsOn: 'Fin de l\'essai le {{date}}',
      cancelAnytime: 'Résiliable à tout moment sans frais',
      cancelBtn: 'Résilier l\'essai gratuit',
      confirmCancel: 'Êtes-vous sûr de vouloir résilier votre essai gratuit ? Vous reviendrez au forfait gratuit et ne pourrez plus bénéficier d\'un nouvel essai.',
      errorCancel: 'Erreur lors de la résiliation de l\'essai'
    },
    
    freeFeatures: {
      quiz: 'Quiz (5 participants max)',
      questionnaire: 'Questionnaires',
      events: 'Événements'
    }
  },

  // Pricing page
  pricing: {
    title: 'Tarifs',
    heroTitle: 'Des forfaits adaptés à vos besoins',
    heroSubtitle: 'Commencez gratuitement, évoluez selon vos besoins',
    faq: 'Questions fréquentes',
    allFeaturesIncluded: 'Toutes les fonctionnalités incluses',
    perMonth: '/mois',
    perYear: '/an',
    startFree: 'Commencer gratuitement',
    getStarted: 'Commencer'
  },

  // Seating Plan
  seatingPlan: {
    title: 'Plan de salle',
    loading: 'Chargement du plan de salle...',
    unsaved: 'Non sauvegardé',
    saved: 'Plan sauvegardé !',
    save: 'Sauvegarder',
    unplacedGuests: 'Invités non placés',
    allGuestsPlaced: 'Tous les invités sont placés !',
    addTable: 'Ajouter une table',
    addElement: 'Ajouter élément',
    entrance: 'Entrée',
    mainEntrance: 'Entrée principale',
    stage: 'Scène',
    entranceAdded: 'Entrée ajoutée',
    stageAdded: 'Scène ajoutée',
    dimensions: 'Dimensions du plan',
    width: 'Largeur',
    height: 'Hauteur',
    default: 'Défaut',
    large: 'Grand',
    extraLarge: 'Très grand',
    xxl: 'XXL',
    zoomIn: 'Zoom +',
    zoomOut: 'Zoom -',
    resetView: 'Réinitialiser la vue',
    fullscreen: 'Plein écran',
    adjustDimensions: 'Ajuster les dimensions',
    toggleInitials: 'Afficher/masquer les initiales',
    noTables: 'Aucune table pour le moment',
    createFirstTable: 'Créer la première table',
    color: 'Couleur',
    shape: 'Forme',
    size: 'Taille',
    guests: 'Invités',
    dragGuestsHere: 'Glissez des invités ici',
    deleteTable: 'Supprimer la table',
    confirmDeleteTable: 'Supprimer la table "{{name}}" ?',
    newTable: 'Nouvelle table',
    tableName: 'Nom de la table',
    tableNamePlaceholder: 'Table 1, Table d\'honneur...',
    capacity: 'Capacité (personnes)',
    create: 'Créer'
  },

  // Table Management
  tableManagement: {
    title: 'Gestion des Tables',
    guestList: 'Liste des Invités',
    addTable: 'Ajouter une Table',
    tables: 'Tables',
    totalCapacity: 'Capacité totale',
    seatedGuests: 'Invités placés',
    notSeated: 'Non placés',
    noGuestAssigned: 'Aucun invité assigné',
    removeFromTable: 'Retirer de la table',
    add: 'Ajouter',
    noTableCreated: 'Aucune table créée',
    createFirstTable: 'Créer la première table',
    unplacedGuests: 'Invités non placés',
    place: 'Placer →',
    addTableTitle: 'Ajouter une Table',
    tableNameLabel: 'Nom de la table *',
    tableNamePlaceholder: 'Ex: Table des Mariés, Table 1...',
    capacityLabel: 'Capacité (nombre de personnes)',
    createTable: 'Créer la table',
    editTableTitle: 'Modifier la Table',
    addTo: 'Ajouter à {{name}}',
    allGuestsSeated: 'Tous les invités sont déjà placés',
    confirmDelete: 'Confirmer la suppression',
    confirmDeleteMessage: 'Êtes-vous sûr de vouloir supprimer la table',
    guestsWillBeUnassigned: 'Les invités assignés à cette table seront marqués comme "non placés".',
    present: 'Présent',
    absent: 'Absent',
    markPresent: 'Marquer comme présent',
    markAbsent: 'Marquer comme absent',
    presenceChanged: '{{name}} marqué(e) comme {{status}}',
    presenceError: 'Erreur lors du changement de statut',
    presentCount: '{{count}}/{{total}} présent(s)',
    sortLabel: 'Trier les tables',
    sortNameAsc: 'Nom (A → Z)',
    sortNameDesc: 'Nom (Z → A)',
    sortCapacityDesc: 'Capacité (décroissante)',
    sortCapacityAsc: 'Capacité (croissante)',
    sortOccupancyDesc: 'Occupation (décroissante)',
    sortOccupancyAsc: 'Occupation (croissante)'
  },

  // QR Scanner
  qrScanner: {
    title: 'Scanner QR Code',
    guestList: 'Liste des Invités',
    tables: 'Tables',
    scanTicket: 'Scanner un billet',
    scanInstructions: 'Pointez la caméra vers le QR code du billet d\'invitation',
    coupleTicket: 'Billet Couple - Sélectionnez la personne',
    present: 'PRÉSENT(E)',
    absent: 'ABSENT(E)',
    name: 'Nom',
    gender: 'Genre',
    male: 'Homme',
    female: 'Femme',
    ticketType: 'Type de billet',
    couple: 'Couple',
    single: 'Single',
    organizerRelation: 'Relation avec l\'organisateur',
    assignedTable: 'Table assignée',
    coupleStatus: 'Statut du couple',
    presentStatus: 'Présent',
    absentStatus: 'Absent',
    presentFemale: 'Présent(e)',
    absentFemale: 'Absent(e)',
    markPresent: 'Marquer Présent',
    markAbsent: 'Marquer Absent',
    scanAnother: 'Scanner un autre billet',
    instructions: 'Instructions',
    instruction1: 'Scannez le QR code présent sur le billet d\'invitation',
    instruction2: 'Vérifiez les informations de l\'invité',
    instruction3: 'Changez le statut de présence si nécessaire',
    instruction4: 'Pour les billets couple, sélectionnez la personne concernée',
    instruction5: 'Vous pouvez scanner le même billet plusieurs fois',
    markedAs: '{{name}} marqué(e) comme {{status}}'
  },

  // Questionnaire Responses
  questionnaireResponses: {
    title: 'Réponses au Questionnaire',
    loading: 'Chargement des réponses...',
    respondents: 'Répondants',
    questions: 'Questions',
    completed: 'Complétés',
    respondentList: 'Liste des répondants',
    noResponses: 'Aucune réponse pour le moment',
    shareToReceive: 'Partagez votre questionnaire pour recevoir des réponses',
    anonymous: 'Anonyme',
    noAnswer: 'Aucune réponse',
    answers: 'réponses',
    abandoned: 'Abandonné',
    completedStatus: 'Complété',
    inProgress: 'En cours',
    responseDetails: 'Détail des réponses',
    sessionAbandoned: 'Session abandonnée',
    noQuestionsAnswered: 'Cette personne a commencé le questionnaire mais n\'a répondu à aucune question.',
    viewFullResults: 'Voir la page de résultats complète',
    deleteResponse: 'Supprimer cette réponse ?',
    deleteResponseMessage: 'La réponse de <strong>{{name}}</strong> sera définitivement supprimée.',
    responseOf: 'La réponse de'
  },

  // Quiz Responses
  quizResponses: {
    loading: 'Chargement des réponses...',
    title: 'Réponses au Quiz',
    participants: 'Participants',
    averageScore: 'Score moyen',
    averageSuccessRate: 'Taux de réussite moyen',
    participantsList: 'Liste des participants',
    noResponses: 'Aucune réponse pour le moment',
    shareQuiz: 'Partagez votre quiz pour recevoir des réponses',
    abandoned: 'Abandonné',
    responseDetails: 'Détail des réponses',
    answer: 'Réponse',
    correctAnswer: 'Bonne réponse',
    sessionAbandoned: 'Session abandonnée',
    noQuestionsAnswered: "Cette personne a commencé le quiz mais n'a répondu à aucune question.",
    viewFullResults: 'Voir la page de résultats complète',
    deleteResponse: 'Supprimer cette réponse ?',
    responseOf: 'La réponse de'
  },

  // Quiz Results
  quizResults: {
    loading: 'Chargement des résultats...',
    title: 'Résultats du Quiz',
    totalScore: 'Score total',
    correct: 'Correctes',
    incorrect: 'Incorrectes',
    success: 'Réussite',
    viewLeaderboard: 'Voir le classement',
    responseDetails: 'Détail des réponses',
    viewAll: 'Voir tout',
    revisionMode: 'Mode révision',
    revisionModeActive: 'Mode révision actif',
    showingIncorrect: 'Affichage des {{count}} réponse(s) incorrecte(s) uniquement',
    yourAnswer: 'Votre réponse',
    noAnswer: 'Pas de réponse',
    correctAnswer: 'Bonne réponse',
    points: 'Points',
    time: 'Temps',
    replay: 'Rejouer',
    home: 'Accueil'
  },

  // Quiz Leaderboard
  quizLeaderboard: {
    loading: 'Chargement du classement...',
    title: 'Classement',
    share: 'Partager',
    uniquePlayers: 'Joueurs uniques',
    gamesPlayed: 'Parties jouées',
    highestScore: 'Meilleur score',
    averageScore: 'Score moyen',
    filterAll: 'Tout',
    filterToday: "Aujourd'hui",
    filterWeek: '7 jours',
    filterMonth: '30 jours',
    noScores: 'Aucun score pour le moment',
    beFirst: 'Soyez le premier à jouer !',
    playNow: 'Jouer maintenant',
    points: 'points',
    joinLeaderboard: 'Jouer et rejoindre le classement'
  },

  // Join Quiz Live
  joinQuizLive: {
    loading: 'Recherche d\'une session en cours...',
    liveSession: 'Session en direct !',
    playersWaiting: '{{count}} joueur(s) en attente',
    joinSession: 'Rejoindre la session',
    noSession: 'Aucune session en cours',
    hostNotStarted: "L'animateur n'a pas encore lancé de session",
    hasSessionCode: 'Avez-vous un code de session ?',
    sessionCodePlaceholder: 'Code de session...',
    or: 'ou',
    playSolo: 'Jouer en solo',
    questions: 'questions',
    perQuestion: 's par question'
  },

  // Event Visitors
  eventVisitors: {
    title: 'Visiteurs inscrits',
    refresh: 'Actualiser',
    totalVisitors: 'Visiteurs total',
    pdfDownloaded: 'PDF téléchargés',
    lastVisit: 'Dernière visite',
    visitorsList: 'Liste des visiteurs',
    registeredOn: 'Inscrit le',
    pdfDownloadedStatus: 'PDF téléchargé',
    noPdf: 'Pas de PDF',
    generatePdf: 'Générer le PDF',
    noVisitors: 'Aucun visiteur inscrit',
    visitorsWillAppear: "Les visiteurs apparaîtront ici lorsqu'ils entreront leur nom",
    deleteVisitor: 'Supprimer ce visiteur ?',
    deleteVisitorConfirm: 'Voulez-vous vraiment supprimer {{name}} de la liste ?',
    backToDashboard: 'Retour au tableau de bord',
    eventNotFound: 'Événement non trouvé',
    unauthorized: "Vous n'êtes pas autorisé à voir cette page",
    loadingError: 'Erreur lors du chargement des données',
    pdfGenerated: 'PDF généré pour {{name}}',
    pdfError: 'Erreur lors de la génération du PDF',
    visitorDeleted: 'Visiteur supprimé',
    deleteError: 'Erreur lors de la suppression',
    invitation: 'Invitation'
  },

  // Planning (Programs & Menus)
  planning: {
    title: 'Planification',
    subtitle: 'Gérez les programmes et menus de votre événement',
    programs: 'Programmes',
    menus: 'Menus',
    shareLinks: 'Liens de partage',
    createProgram: 'Créer un programme',
    editProgram: 'Modifier le programme',
    createMenu: 'Créer un menu',
    editMenu: 'Modifier le menu',
    noProgramsYet: 'Aucun programme créé',
    noMenusYet: 'Aucun menu créé',
    noLinksYet: 'Aucun lien de partage généré',
    generateQR: 'Générer QR-Code / Lien',
    generateQRTitle: 'Générer un lien de partage',
    generateQRDescription: 'Sélectionnez les éléments à partager avec vos invités',
    editQRTitle: 'Modifier le QR code',
    editQRDescription: 'Ajoutez ou retirez des éléments. Le QR code et le lien restent identiques.',
    saveChanges: 'Enregistrer',
    linkUpdated: 'QR code mis à jour !',
    generate: 'Générer',
    downloadQR: 'Télécharger QR',
    noContentToShare: 'Aucun contenu à partager',
    createContentFirst: 'Créez d\'abord des programmes ou des menus',
    includeGuestbook: 'Inclure le livre d\'or',
    confirmDeleteProgram: 'Êtes-vous sûr de vouloir supprimer ce programme ?',
    confirmDeleteMenu: 'Êtes-vous sûr de vouloir supprimer ce menu ?',
    selectToView: 'Choisissez ce que vous souhaitez consulter',
    invalidLink: 'Ce lien de partage n\'est plus valide',
    eventNotFound: 'Événement non trouvé',
    noContentAvailable: 'Aucun contenu disponible',
    program: {
      info: 'Informations du programme',
      title: 'Titre du programme',
      titlePlaceholder: 'Ex: Le Planning de la journée',
      titleRequired: 'Le titre est requis',
      date: 'Date / Période',
      datePlaceholder: 'Ex: Samedi 14 Juin',
      dateHint: 'Texte libre - écrivez comme vous voulez',
      items: 'Activités',
      addItem: 'Ajouter une activité',
      addFirstItem: 'Ajouter la première activité',
      noItems: 'Aucune activité dans ce programme',
      activityName: 'Nom de l\'activité',
      activityNamePlaceholder: 'Ex: Accueil des invités',
      description: 'Description',
      descriptionPlaceholder: 'Décrivez cette activité...',
      bgColor: 'Couleur de fond',
      textColor: 'Couleur du texte',
      images: 'Images',
      viewMap: 'Voir le plan',
      activities: 'activités'
    },
    menu: {
      info: 'Informations du menu',
      title: 'Titre du menu',
      titlePlaceholder: 'Ex: Menu du Dîner de Gala',
      titleRequired: 'Le titre est requis',
      starters: 'Les Entrées',
      mains: 'Les Plats de Résistance',
      desserts: 'Les Desserts',
      dish: 'Plat',
      addDish: 'Ajouter un plat',
      dishName: 'Nom du plat',
      dishNamePlaceholder: 'Ex: Foie gras maison',
      dishDescription: 'Description du plat',
      dishDescriptionPlaceholder: 'Décrivez ce plat...',
      dishImage: 'Image du plat'
    },
    editor: {
      bold: 'Gras',
      italic: 'Italique',
      textColor: 'Couleur du texte',
      mapLinkPlaceholder: 'Lien Google Maps...'
    }
  },

  // Image Upload
  imageUpload: {
    import: 'Importer',
    urlPlaceholder: 'https://exemple.com/image.jpg',
    uploadInProgress: 'Upload en cours...',
    imageUploaded: 'Image uploadée',
    deleteImage: "Supprimer l'image",
    clickToSelect: 'Cliquez pour sélectionner une image',
    maxSize: 'PNG, JPG, GIF jusqu\'à 5 Mo',
    preview: 'Aperçu',
    selectImage: 'Veuillez sélectionner une image',
    maxSizeError: "L'image ne doit pas dépasser 60 Mo",
    maxSizeErrorWithSize: "L'image ne doit pas dépasser {{size}} Mo",
    storageNotConfigured: 'Firebase Storage n\'est pas configuré. Veuillez activer Storage dans la console Firebase.'
  },

  // Tasks
  tasks: {
    title: 'Tâches',
    add: 'Ajouter une tâche',
    addFirst: 'Ajouter ma première tâche',
    selectTask: 'Choisir une tâche',
    selectTaskDescription: 'Sélectionnez une tâche prédéfinie ou créez-en une personnalisée',
    createCustom: 'Créer une tâche personnalisée',
    predefined: 'Tâches prédéfinies pour le mariage',
    newTask: 'Nouvelle tâche',
    editTask: 'Modifier la tâche',
    taskName: 'Nom de la tâche',
    taskNamePlaceholder: 'Ex: Réserver le photographe',
    description: 'Description',
    descriptionPlaceholder: 'Décrivez les détails de cette tâche...',
    deadline: 'Date limite',
    cost: 'Coût estimé',
    responsibles: 'Responsables',
    responsibleName: 'Nom du responsable',
    responsibleContact: 'Téléphone / Email',
    addResponsible: 'Ajouter un responsable',
    location: 'Lieu',
    locationNamePlaceholder: 'Nom du lieu (ex: Studio Photo Martin)',
    locationUrlPlaceholder: 'Lien Google Maps ou itinéraire',
    directions: 'Itinéraire',
    reminder: 'Rappel',
    reminderOn: 'Rappel actif',
    setReminder: 'Configurer un rappel',
    configure: 'Configurer',
    venue: 'Lieu/Salle',
    quantity: 'Quantité',
    notes: 'Notes',
    notesPlaceholder: 'Notes additionnelles...',
    responses: 'Suivi et mises à jour',
    addResponse: 'Ajouter une mise à jour...',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette tâche ?',
    all: 'Toutes',
    pending: 'En attente',
    completed: 'Terminées',
    overdue: 'En retard',
    search: 'Rechercher une tâche...',
    empty: 'Aucune tâche',
    emptyDescription: 'Commencez à organiser votre événement en ajoutant des tâches',
    markComplete: 'Marquer comme terminée',
    markIncomplete: 'Marquer comme non terminée',
    today: 'Aujourd\'hui',
    tomorrow: 'Demain',
    daysLeft: '{{days}} jours restants',
    nameRequired: 'Le nom de la tâche est requis',
    saveError: 'Erreur lors de la sauvegarde'
  },

  // Notifications
  notifications: {
    title: 'Notifications',
    empty: 'Aucune notification',
    emptyDescription: 'Vous recevrez des rappels pour vos tâches ici',
    markAllRead: 'Tout marquer comme lu',
    markRead: 'Marquer comme lu',
    viewAll: 'Voir toutes les notifications',
    new: 'Nouveau',
    justNow: 'À l\'instant',
    minutesAgo: 'Il y a {{count}} min',
    hoursAgo: 'Il y a {{count}}h',
    daysAgo: 'Il y a {{count}}j',
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    all: 'Toutes',
    unread: 'Non lues',
    read: 'Lues',
    unreadCount: '{{count}} non lue(s)',
    allRead: 'Toutes les notifications sont lues',
    noUnread: 'Aucune notification non lue',
    noRead: 'Aucune notification lue',
    chatEscalation: '💬 Nouveau chat en attente',
    chatEscalationMessage: '{{userName}} demande de l\'aide humaine',
    goToChat: 'Voir le chat'
  },

  // Questionnaire Results
  questionnaireResults: {
    loading: 'Chargement des résultats...',
    title: 'Vos Réponses',
    completedOn: 'Questionnaire complété le',
    unknownDate: 'Date inconnue',
    answersRecorded: 'réponses enregistrées',
    responseDetails: 'Détail des réponses',
    noAnswer: 'Pas de réponse',
    noAnswersRecorded: 'Aucune réponse enregistrée',
    backToHome: "Retour à l'accueil"
  },

  // Admin Quiz Music
  adminQuizMusic: {
    loading: 'Chargement des musiques...',
    title: 'Gestion des Musiques du Quiz',
    subtitle: 'Gérez les musiques du lobby, les effets sonores et les musiques de gameplay',
    backToAdmin: 'Retour au panneau admin',
    lobbyTab: 'Lobby',
    effectsTab: 'Effets',
    gameplayTab: 'Gameplay',
    lobbyMusic: 'Musiques du Lobby',
    lobbyMusicDesc: 'Ces musiques sont jouées en boucle aléatoire dans la salle d\'attente.',
    soundEffects: 'Effets Sonores',
    soundEffectsDesc: 'Ces sons sont joués à des moments spécifiques du quiz.',
    gameplayMusic: 'Musiques de Gameplay',
    gameplayMusicDesc: 'Chaque durée de question a sa propre banque de musiques.',
    questionDuration: 'Question de {{duration}}s \u2192 Musique de ~{{musicDuration}}s',
    lobbyMusicTitle: '\ud83c\udfb5 Musiques du Lobby',
    lobbyMusicSubtitle: 'Jouées en boucle aléatoire dans la salle d\'attente',
    countdownTitle: '\u23f1\ufe0f Compte \u00e0 rebours (3-2-1)',
    countdownSubtitle: 'Son joué avant le début du jeu',
    transitionTitle: '\ud83d\udd04 Transition entre questions',
    transitionSubtitle: 'Son court entre deux questions',
    resultsTitle: '\ud83d\udcca Résultats / Statistiques',
    resultsSubtitle: "Musique pendant l'affichage des résultats",
    podiumTitle: '\ud83c\udfc6 Podium Final',
    podiumSubtitle: 'Musique festive pour le podium',
    questionsTitle: '\ud83c\udfae Questions de {{duration}}s',
    questionsSubtitle: 'Musiques pour les questions de {{duration}} secondes',
    uploading: 'Upload en cours...',
    addAudio: 'Cliquez pour ajouter des fichiers audio',
    noMusic: 'Aucune musique',
    unknownError: 'Erreur inconnue'
  },

  // Footer
  footer: {
    description: 'La plateforme interactive pour créer des quiz, questionnaires et gérer vos événements.',
    support: 'Support',
    legal: 'Mentions légales',
    terms: 'Conditions Générales d\'Utilisation',
    privacy: 'Protection des données',
    help: 'Aide',
    rights: 'Tous droits réservés.'
  },

  // Help / Aide
  help: {
    // Hero
    hero: {
      title: 'Centre d\'aide HugoQuiz',
      subtitle: 'Découvrez toutes les fonctionnalités de HugoQuiz et apprenez à les utiliser efficacement pour créer des événements mémorables.'
    },
    
    // Tabs
    tabs: {
      faq: 'Questions fréquentes',
      docs: 'Documentation complète'
    },
    
    // Tips
    tips: {
      title: 'Conseils pour bien démarrer',
      tip1: 'Commencez par créer un événement simple pour vous familiariser avec l\'interface.',
      tip2: 'Utilisez les modèles de quiz pour gagner du temps lors de la création.',
      tip3: 'Testez toujours votre quiz en mode aperçu avant de le partager.',
      tip4: 'Consultez les statistiques après chaque événement pour vous améliorer.'
    },
    
    // FAQ
    faq: {
      title: 'Questions fréquemment posées',
      q1: {
        question: 'Comment créer mon premier événement ?',
        answer: 'Pour créer votre premier événement, connectez-vous à votre compte HugoQuiz, puis cliquez sur "Créer un événement" depuis votre tableau de bord. Remplissez les informations de base (nom, date, lieu, description) et personnalisez les options selon vos besoins. Vous pourrez ensuite ajouter des invités, créer un programme, gérer les tables et bien plus encore.'
      },
      q2: {
        question: 'Quelle est la différence entre un quiz en direct et un quiz asynchrone ?',
        answer: 'Le quiz en direct (Live) se joue en temps réel avec tous les participants connectés simultanément. L\'animateur contrôle le rythme et affiche les questions une par une. C\'est idéal pour les soirées, mariages ou team buildings.\n\nLe quiz asynchrone permet aux participants de jouer à leur propre rythme, quand ils le souhaitent. Chacun répond aux questions individuellement et les résultats sont compilés automatiquement. Parfait pour les formations ou les enquêtes.'
      },
      q3: {
        question: 'Comment inviter des participants à mon événement ?',
        answer: 'Vous pouvez inviter des participants de plusieurs façons :\n• Ajouter manuellement leurs coordonnées dans la liste des invités\n• Importer un fichier Excel/CSV avec la liste des invités\n• Partager un lien d\'invitation ou un QR code\n• Envoyer des invitations par email directement depuis HugoQuiz\n\nChaque invité recevra un accès personnalisé avec un QR code unique pour le jour de l\'événement.'
      },
      q4: {
        question: 'Comment fonctionne le système de tables et le plan de salle ?',
        answer: 'Le système de gestion des tables vous permet de :\n• Créer différents types de tables (rondes, rectangulaires, carrées)\n• Définir le nombre de places par table\n• Glisser-déposer les invités sur les tables\n• Visualiser le plan de salle en temps réel\n• Imprimer les marque-places et le plan complet\n\nLe plan de salle interactif vous aide à optimiser l\'agencement et à gérer les affinités entre invités.'
      },
      q5: {
        question: 'Puis-je personnaliser l\'apparence de mes quiz ?',
        answer: 'Oui, HugoQuiz offre de nombreuses options de personnalisation :\n• Choisir parmi plusieurs thèmes visuels\n• Ajouter votre logo et vos images\n• Personnaliser les couleurs principales\n• Ajouter des musiques de fond\n• Configurer le temps par question\n• Personnaliser les messages de fin\n\nCela vous permet de créer une expérience cohérente avec l\'identité de votre événement.'
      },
      q6: {
        question: 'Comment fonctionne le livre d\'or numérique ?',
        answer: 'Le livre d\'or numérique permet à vos invités de laisser des messages, photos et vidéos pendant ou après l\'événement. Ils peuvent :\n• Écrire des messages personnalisés\n• Ajouter des photos ou selfies\n• Enregistrer des messages vocaux\n• Réagir aux messages des autres\n\nTous les souvenirs sont conservés et vous pouvez les exporter en format PDF ou album photo.'
      },
      q7: {
        question: 'Comment scanner les billets/QR codes le jour de l\'événement ?',
        answer: 'Le jour de l\'événement, utilisez la fonction "Scanner QR" depuis votre tableau de bord :\n• Autorisez l\'accès à la caméra de votre appareil\n• Scannez le QR code de chaque invité\n• Le système confirme instantanément la validité\n• L\'invité est automatiquement marqué comme "arrivé"\n• Vous voyez en temps réel le taux de présence\n\nVous pouvez utiliser plusieurs appareils simultanément pour accélérer l\'accueil.'
      },
      q8: {
        question: 'Comment créer des questions conditionnelles dans un questionnaire ?',
        answer: 'Les questions conditionnelles permettent d\'afficher certaines questions selon les réponses précédentes. Pour les configurer :\n1. Créez votre question principale\n2. Activez l\'option "Question conditionnelle"\n3. Définissez la condition (ex: "Si réponse = Oui")\n4. Sélectionnez la question à afficher si la condition est remplie\n\nC\'est idéal pour les RSVP (demander les restrictions alimentaires seulement si la personne confirme sa présence).'
      },
      q9: {
        question: 'Comment fonctionne l\'abonnement et puis-je changer de forfait ?',
        answer: 'HugoQuiz propose plusieurs forfaits adaptés à vos besoins :\n• Gratuit : fonctionnalités de base, parfait pour découvrir\n• Premium : fonctionnalités avancées pour les particuliers\n• Entreprise : toutes les fonctionnalités + support prioritaire\n\nVous pouvez changer de forfait à tout moment. Le changement prend effet immédiatement et le montant est calculé au prorata.'
      },
      q10: {
        question: 'Mes données sont-elles sécurisées ?',
        answer: 'La sécurité de vos données est notre priorité :\n• Hébergement sur des serveurs européens sécurisés\n• Chiffrement SSL/TLS de toutes les communications\n• Conformité RGPD complète\n• Sauvegardes automatiques quotidiennes\n• Authentification sécurisée\n• Possibilité de supprimer vos données à tout moment\n\nVous restez propriétaire de vos données et pouvez les exporter quand vous le souhaitez.'
      },
      q11: {
        question: 'Comment ajouter de la musique à mon quiz ?',
        answer: 'Pour ajouter de la musique à votre quiz :\n1. Accédez aux paramètres du quiz\n2. Section "Musique et sons"\n3. Uploadez vos fichiers audio (MP3, WAV)\n4. Configurez la musique pour chaque phase :\n   • Attente des joueurs\n   • Pendant les questions\n   • Réponse correcte/incorrecte\n   • Podium final\n\nVous pouvez aussi utiliser la bibliothèque de musiques libres de droits intégrée.'
      },
      q12: {
        question: 'Comment voir les statistiques de mon événement ?',
        answer: 'Les statistiques complètes sont accessibles depuis la page de chaque événement :\n• Taux de réponse aux invitations (RSVP)\n• Nombre de visiteurs du questionnaire\n• Statistiques détaillées du quiz (scores, temps de réponse)\n• Taux de présence le jour J\n• Messages du livre d\'or\n• Graphiques et tendances\n\nVous pouvez exporter ces statistiques en PDF ou Excel pour vos archives.'
      },
      q13: {
        question: 'Puis-je utiliser HugoQuiz sur mobile ?',
        answer: 'Oui, HugoQuiz est entièrement responsive et fonctionne parfaitement sur :\n• Smartphones (iOS et Android)\n• Tablettes\n• Ordinateurs\n\nLes participants peuvent jouer aux quiz et accéder aux fonctionnalités depuis n\'importe quel appareil avec un navigateur web moderne. Aucune application à installer !'
      },
      q14: {
        question: 'Comment contacter le support en cas de problème ?',
        answer: 'Plusieurs options pour nous contacter :\n• Chat en direct (icône en bas à droite)\n• Email : contact@hugoquiz.com\n• Documentation et tutoriels en ligne\n\nNotre équipe répond généralement sous 24h en jours ouvrés. Les abonnés Premium et Entreprise bénéficient d\'un support prioritaire.'
      },
      q15: {
        question: 'Puis-je essayer HugoQuiz gratuitement avant de m\'abonner ?',
        answer: 'Absolument ! HugoQuiz propose :\n• Un forfait gratuit permanent avec les fonctionnalités essentielles\n• Un essai gratuit de 7 jours pour les forfaits payants\n• Aucune carte bancaire requise pour le forfait gratuit\n\nL\'essai de 7 jours vous donne accès à TOUTES les fonctionnalités premium. Vous pouvez annuler à tout moment sans frais pendant la période d\'essai.'
      }
    },
    
    // Documentation
    docs: {
      // Events section
      events: {
        title: 'Gestion des événements',
        description: 'Créez et gérez des événements complets avec toutes les fonctionnalités nécessaires.',
        guests: {
          title: 'Liste des invités',
          content: 'Gérez votre liste d\'invités de manière efficace :\n\n• Ajoutez des invités manuellement ou importez depuis Excel/CSV\n• Suivez les confirmations de présence (RSVP) en temps réel\n• Envoyez des invitations par email avec QR code personnalisé\n• Gérez les accompagnants et les enfants\n• Catégorisez vos invités (famille, amis, collègues)\n• Exportez la liste complète à tout moment\n• Suivez les restrictions alimentaires et allergies'
        },
        gifts: {
          title: 'Liste de cadeaux',
          content: 'Créez une liste de cadeaux collaborative :\n\n• Ajoutez des idées cadeaux avec photos et liens\n• Les invités peuvent réserver un cadeau (visible par eux seuls)\n• Évitez les doublons grâce au système de réservation\n• Définissez des priorités et des catégories\n• Ajoutez des cagnottes pour les gros cadeaux\n• Recevez des notifications quand un cadeau est réservé\n• Remerciez facilement grâce au suivi intégré'
        },
        tables: {
          title: 'Gestion des tables',
          content: 'Organisez parfaitement votre réception :\n\n• Créez différents types de tables (rondes, rectangulaires, cocktail)\n• Définissez le nombre de places par table\n• Nommez vos tables (numéros, noms de fleurs, villes...)\n• Assignez les invités par glisser-déposer\n• Visualisez les places restantes\n• Imprimez les marque-places personnalisés\n• Gérez les changements de dernière minute facilement'
        },
        qrcode: {
          title: 'Scanner QR & Accueil',
          content: 'Simplifiez l\'accueil de vos invités :\n\n• Chaque invité reçoit un QR code unique\n• Scannez rapidement avec n\'importe quel smartphone\n• Confirmation visuelle et sonore immédiate\n• Suivi en temps réel des arrivées\n• Détection des QR codes invalides ou déjà scannés\n• Statistiques de présence en direct\n• Plusieurs postes d\'accueil simultanés possibles'
        },
        seating: {
          title: 'Plan de salle interactif',
          content: 'Visualisez et optimisez votre espace :\n\n• Éditeur drag & drop intuitif\n• Positionnez tables, scène, piste de danse, buffet\n• Ajoutez des éléments décoratifs (entrée, bar, photo booth)\n• Redimensionnez et orientez librement les éléments\n• Sauvegarde automatique des modifications\n• Vue d\'ensemble pour les grands espaces\n• Export et impression du plan final'
        },
        guestbook: {
          title: 'Livre d\'or numérique',
          content: 'Collectez des souvenirs précieux :\n\n• Interface élégante pour les messages\n• Ajout de photos et selfies par les invités\n• Messages vocaux ou vidéos optionnels\n• Modération des contenus si nécessaire\n• Réactions et likes sur les messages\n• Export en PDF format album souvenir\n• Accessible avant, pendant et après l\'événement'
        },
        stats: {
          title: 'Statistiques détaillées',
          content: 'Analysez votre événement en profondeur :\n\n• Taux de réponse RSVP avec évolution temporelle\n• Statistiques de présence le jour J\n• Analyse des questionnaires et quiz\n• Engagement sur le livre d\'or\n• Graphiques visuels et exportables\n• Comparaison avec vos événements précédents\n• Indicateurs clés de performance (KPI)'
        },
        planning: {
          title: 'Planification & Timeline',
          content: 'Organisez chaque détail de votre événement :\n\n• Créez une timeline détaillée\n• Définissez des jalons et échéances\n• Assignez des responsables pour chaque tâche\n• Vue calendrier ou liste selon préférence\n• Rappels automatiques par email\n• Suivi de l\'avancement global\n• Partage avec vos prestataires'
        },
        program: {
          title: 'Programme de l\'événement',
          content: 'Communiquez le déroulé à vos invités :\n\n• Créez un programme horaire détaillé\n• Ajoutez des icônes et descriptions\n• Définissez les lieux pour chaque activité\n• Programme accessible via l\'invitation\n• Mise à jour en temps réel si changement\n• Notifications push optionnelles\n• Version imprimable disponible'
        },
        menu: {
          title: 'Carte & Menu',
          content: 'Présentez votre menu avec élégance :\n\n• Créez plusieurs menus (adultes, enfants, végétarien)\n• Ajoutez entrées, plats, desserts, boissons\n• Indiquez les allergènes et origines\n• Intégrez les photos des plats\n• Menu consultable par les invités\n• Liez les choix au questionnaire RSVP\n• Export PDF pour impression'
        },
        tasks: {
          title: 'Gestion des tâches',
          content: 'Ne rien oublier pour le jour J :\n\n• Créez des listes de tâches par catégorie\n• Assignez des responsables\n• Définissez des dates limites\n• Suivez l\'avancement en pourcentage\n• Recevez des rappels automatiques\n• Cochez les tâches terminées\n• Collaborez avec votre équipe d\'organisation'
        }
      },
      
      // Quiz section
      quiz: {
        title: 'Quiz interactifs',
        description: 'Animez vos événements avec des quiz ludiques et engageants.',
        create: {
          title: 'Création de quiz',
          content: 'Créez des quiz captivants en quelques minutes :\n\n• Interface intuitive de création\n• Questions à choix multiples, vrai/faux, texte libre\n• Ajoutez des images et médias aux questions\n• Définissez le temps de réponse par question\n• Configurez les points selon la difficulté\n• Prévisualisez avant de publier\n• Dupliquez et modifiez des quiz existants'
        },
        live: {
          title: 'Mode Live (temps réel)',
          content: 'Animez un quiz en direct comme un pro :\n\n• Salle d\'attente avec musique d\'ambiance\n• Les joueurs rejoignent via code ou QR code\n• Vous contrôlez le rythme des questions\n• Affichage synchronisé sur tous les écrans\n• Classement en temps réel entre les questions\n• Réactions et émojis des participants\n• Podium animé avec musique à la fin\n• Parfait pour les mariages, team buildings, soirées'
        },
        async: {
          title: 'Mode asynchrone',
          content: 'Laissez les joueurs participer à leur rythme :\n\n• Partagez un lien unique\n• Chacun joue quand il veut\n• Temps limité ou illimité par question\n• Les scores s\'accumulent automatiquement\n• Classement mis à jour en continu\n• Idéal pour les formations, révisions, enquêtes\n• Résultats consultables à tout moment'
        },
        leaderboard: {
          title: 'Classement & Podium',
          content: 'Célébrez les gagnants avec style :\n\n• Classement en temps réel pendant le quiz\n• Podium animé avec effets visuels\n• Musique de victoire personnalisable\n• Affichage des scores et temps de réponse\n• Export du classement complet\n• Certificats de participation optionnels\n• Partage sur les réseaux sociaux'
        },
        stats: {
          title: 'Statistiques de quiz',
          content: 'Analysez les performances en détail :\n\n• Taux de bonnes réponses par question\n• Temps moyen de réponse\n• Questions les plus difficiles\n• Évolution des scores\n• Comparaison entre sessions\n• Identification des points à améliorer\n• Export des données pour analyse approfondie'
        },
        music: {
          title: 'Musique & Sons',
          content: 'Créez une ambiance immersive :\n\n• Musique de salle d\'attente\n• Sons pendant le compte à rebours\n• Jingle de bonne/mauvaise réponse\n• Musique de suspense entre questions\n• Fanfare pour le podium\n• Bibliothèque de musiques libres incluse\n• Uploadez vos propres musiques'
        },
        media: {
          title: 'Images & Médias',
          content: 'Enrichissez vos questions visuellement :\n\n• Ajoutez des images aux questions\n• Intégrez des vidéos YouTube\n• Questions "Devinez l\'image"\n• Galerie de médias réutilisables\n• Optimisation automatique des images\n• Support des formats courants (JPG, PNG, GIF)\n• Stockage inclus selon votre forfait'
        },
        settings: {
          title: 'Paramètres avancés',
          content: 'Personnalisez chaque aspect du quiz :\n\n• Nombre de participants max\n• Autoriser les retardataires ou non\n• Mélanger l\'ordre des questions\n• Mélanger l\'ordre des réponses\n• Afficher ou masquer les scores intermédiaires\n• Mode sombre ou clair\n• Personnalisation des couleurs'
        }
      },
      
      // Questionnaire section
      questionnaire: {
        title: 'Questionnaires intelligents',
        description: 'Collectez des informations précises avec des formulaires flexibles.',
        create: {
          title: 'Création de questionnaires',
          content: 'Concevez des questionnaires professionnels :\n\n• Éditeur visuel intuitif\n• Glisser-déposer pour réorganiser\n• Sections et pages multiples\n• Description et instructions personnalisées\n• Prévisualisation en temps réel\n• Duplication de questionnaires existants\n• Modèles prêts à l\'emploi (RSVP, satisfaction...)'
        },
        conditional: {
          title: 'Questions conditionnelles',
          content: 'Créez des parcours intelligents et personnalisés :\n\n• Affichez des questions selon les réponses précédentes\n• Exemple : "Combien d\'accompagnants ?" seulement si "Viendrez-vous ? = Oui"\n• Conditions multiples (ET/OU)\n• Saut de sections entières\n• Parcours différents selon le profil\n• Logique visible dans l\'éditeur\n• Testez les différents scénarios facilement'
        },
        types: {
          title: 'Types de questions',
          content: 'Choisissez le format adapté à chaque besoin :\n\n• Choix unique (radio)\n• Choix multiples (cases à cocher)\n• Texte court ou long\n• Email, téléphone avec validation\n• Date et heure\n• Échelle de notation (1-5, 1-10)\n• Upload de fichiers\n• Classement par ordre de préférence'
        },
        results: {
          title: 'Résultats & Analyse',
          content: 'Exploitez les réponses efficacement :\n\n• Vue d\'ensemble des statistiques\n• Graphiques par question\n• Export Excel/CSV complet\n• Filtrage par critères\n• Réponses individuelles détaillées\n• Évolution temporelle des réponses\n• Rapports automatiques par email'
        },
        customization: {
          title: 'Personnalisation',
          content: 'Adaptez le questionnaire à votre image :\n\n• Logo et couleurs personnalisées\n• Message d\'accueil personnalisé\n• Page de confirmation sur mesure\n• Redirection après soumission\n• Limiter le nombre de réponses\n• Date de fermeture automatique\n• Accès par mot de passe optionnel'
        }
      },
      
      // Account section
      account: {
        title: 'Mon compte',
        description: 'Gérez votre profil, abonnement et préférences.',
        subscription: {
          title: 'Abonnement & Facturation',
          content: 'Gérez votre abonnement facilement :\n\n• Voir le forfait actuel et ses limites\n• Changer de forfait à tout moment\n• Historique des factures\n• Mise à jour des informations de paiement\n• Annulation avec remboursement sous 30 min\n• Essai gratuit de 7 jours disponible\n• Support prioritaire selon le forfait'
        },
        security: {
          title: 'Sécurité du compte',
          content: 'Protégez votre compte efficacement :\n\n• Modification du mot de passe\n• Historique des connexions\n• Déconnexion de tous les appareils\n• Suppression du compte et des données\n• Conformité RGPD garantie\n• Export de toutes vos données\n• Vérification en deux étapes (à venir)'
        },
        notifications: {
          title: 'Notifications',
          content: 'Restez informé sans être submergé :\n\n• Notifications par email personnalisables\n• Alertes pour les nouvelles réponses\n• Rappels d\'événements à venir\n• Notifications de tâches\n• Résumé hebdomadaire optionnel\n• Centre de notifications in-app\n• Désactivation sélective possible'
        },
        support: {
          title: 'Support & Assistance',
          content: 'Nous sommes là pour vous aider :\n\n• Chat en direct avec notre équipe\n• Support par email sous 24h\n• Documentation complète en ligne\n• Tutoriels vidéo pas à pas\n• FAQ régulièrement mise à jour\n• Support prioritaire pour Premium\n• Accompagnement personnalisé Entreprise'
        }
      }
    },
    
    // Contact section
    contact: {
      title: 'Besoin d\'aide supplémentaire ?',
      description: 'Notre équipe est disponible pour répondre à toutes vos questions et vous accompagner dans l\'utilisation de HugoQuiz.',
      email: 'Nous contacter par email'
    }
  },

  services: {
    marketplaceTitle: 'Trouvez le bon prestataire',
    marketplaceSubtitle: 'Des professionnels de confiance pour tous vos besoins et projets.',
    searchPlaceholder: 'Rechercher un service, une entreprise...',
    noServices: 'Aucun service pour le moment',
    noServicesDesc: 'Soyez le premier à proposer votre service dans cette catégorie.',
    proposeService: 'Proposer un service',
    onQuote: 'Sur devis',
    views: 'vues',
    window: 'Onglet',
    notFound: 'Service introuvable',
    notYours: 'Ce service ne vous appartient pas',
    updated: 'Service mis à jour !',
    submitted: 'Service envoyé ! Il sera publié après validation.',
    createService: 'Créer un service',
    editTitle: 'Modifier le service',
    createSubtitle: 'Présentez votre activité de façon claire et attrayante.',
    autoTranslateHint: 'Vos textes seront automatiquement traduits dans les autres langues (anglais, allemand, néerlandais) lors de la publication.',
    generalInfo: 'Informations générales',
    businessName: 'Nom de l\'entreprise',
    serviceTitle: 'Titre du service',
    titlePlaceholder: 'Ex: Photographe & Vidéaste professionnel',
    tagline: 'Phrase d’accroche',
    taglinePlaceholder: 'Une courte phrase qui résume votre offre',
    category: 'Catégorie',
    serviceType: 'Type de service',
    country: 'Pays',
    city: 'Ville',
    cityPlaceholder: 'Choisissez ou saisissez votre ville',
    coverImage: 'Image de couverture',
    profilePhoto: 'Photo de profil',
    profilePhotoHint: "Si vous n'ajoutez pas de photo, les initiales de votre nom seront affichées.",
    price: 'Prix (optionnel)',
    pricePlaceholder: 'Ex: À partir de 350 € / Sur devis',
    priceComment: 'Commentaire sur le prix',
    priceCommentPlaceholder: 'Ex: pour une prestation de 2h',
    contactInfo: 'Coordonnées de contact',
    contactInfoDesc: 'Choisissez les coordonnées visibles par les visiteurs. Un formulaire de contact est toujours affiché.',
    email: 'E-mail',
    showEmail: 'Afficher mon e-mail publiquement',
    phone: 'Téléphone',
    showPhone: 'Afficher mon numéro publiquement',
    windows: 'Fenêtres / Onglets',
    addWindow: 'Ajouter un onglet',
    windowTitle: 'Titre de l\'onglet (ex: Mariage)',
    imageBlock: 'Image',
    textBlock: 'Texte',
    textPlaceholder: 'Écrivez votre paragraphe...',
    captionPlaceholder: 'Légende de l\'image (optionnel)',
    noBlocks: 'Ajoutez du texte ou des images à cet onglet.',
    addText: 'Ajouter un texte',
    addImage: 'Ajouter une image',
    verifyFirst: 'Vérifiez votre identité d\'abord',
    verifyFirstDesc: 'Pour publier un service, vous devez d\'abord faire vérifier votre identité. C\'est une étape unique et sécurisée.',
    startVerification: 'Commencer la vérification',
    notAvailable: 'Service non disponible',
    notAvailableDesc: 'Ce service n\'existe pas ou n\'est pas encore publié.',
    backToMarketplace: 'Tous les services',
    previewPending: 'Aperçu — ce service est en attente de validation par un administrateur.',
    previewRejected: 'Ce service a été rejeté.',
    previewRestricted: 'L\'affichage de ce service a été restreint par un administrateur.',
    emptyWindow: 'Aucun contenu dans cet onglet.',
    errors: {
      businessName: 'Indiquez le nom de l\'entreprise.',
      title: 'Indiquez un titre pour votre service.',
      type: 'Choisissez un type de service.',
      country: 'Choisissez votre pays.',
      city: 'Indiquez votre ville.',
      email: 'Renseignez un e-mail de contact.'
    },
    status: {
      pending: 'En attente de validation',
      approved: 'Publié',
      rejected: 'Rejeté',
      restricted: 'Restreint'
    },
    categories: {
      evenement: 'Événement', maison: 'Maison & Travaux', beaute: 'Beauté & Bien-être', formation: 'Cours & Formation', digital: 'Informatique & Digital', mode: 'Mode & Couture', transport: 'Transport & Livraison', autre: 'Autres services'
    },
    types: {
      photographe: 'Photographe', videaste: 'Vidéaste', 'event-planner': 'Event-planner', dj: 'DJ', traiteur: 'Traiteur', decoration: 'Décoration', animation: 'Animation', 'location-salle': 'Location de salle', fleuriste: 'Fleuriste', musicien: 'Musicien', mc: 'Maître de cérémonie', securite: 'Sécurité', plombier: 'Plombier', electricien: 'Électricien', menuisier: 'Menuisier', peintre: 'Peintre', jardinier: 'Jardinier', demenagement: 'Déménagement', nettoyage: 'Nettoyage', bricolage: 'Bricolage', coiffeur: 'Coiffeur', maquilleur: 'Maquilleur', estheticienne: 'Esthéticienne', manucure: 'Manucure', massage: 'Massage', 'coach-sportif': 'Coach sportif', 'cours-particuliers': 'Cours particuliers', langues: 'Langues', musique: 'Musique', 'soutien-scolaire': 'Soutien scolaire', coaching: 'Coaching', developpeur: 'Développeur', graphiste: 'Graphiste', webdesign: 'Web design', marketing: 'Marketing', redaction: 'Rédaction', 'community-manager': 'Community manager', couture: 'Couture', stylisme: 'Stylisme', retouche: 'Retouche', creation: 'Création', chauffeur: 'Chauffeur', livraison: 'Livraison', vtc: 'VTC', demenageur: 'Déménageur', autre: 'Autre'
    },
    idDocuments: {
      'carte-identite': 'Carte d\'identité', 'passeport-ue': 'Passeport (Union européenne)', 'carte-sejour': 'Carte de séjour', visa: 'Visa', 'permis-conduire': 'Permis de conduire'
    },
    marketplace: {
      navLink: 'Services',
      homeTitle: 'Trouvez le prestataire idéal',
      homeSubtitle: 'Photographes, DJ, traiteurs, event-planners et bien plus — des professionnels vérifiés pour tous vos projets.',
      browseAll: 'Parcourir les services',
      becomeProvider: 'Proposer mes services'
    },
    verify: {
      title: 'Vérification d\'identité',
      subtitle: 'Une étape unique pour devenir prestataire de confiance.',
      approvedTitle: 'Identité vérifiée ✅',
      approvedDesc: 'Vous pouvez maintenant créer et publier vos services.',
      pendingTitle: 'Vérification en cours',
      pendingDesc: 'Notre équipe examine votre demande. Vous serez notifié par e-mail et dans vos notifications dès qu’elle sera traitée.',
      rejectedTitle: 'Demande précédente rejetée',
      resubmit: 'Vous pouvez soumettre de nouveaux documents ci-dessous.',
      explain: 'Pour garantir la sécurité de la plateforme, nous vérifions l\'identité de chaque prestataire. Fournissez une pièce d\'identité valide et enregistrez une courte vidéo de vous afin que notre équipe puisse confirmer que l\'identité vous correspond. Ces documents sont confidentiels et utilisés uniquement à des fins de vérification.',
      idType: 'Type de pièce d\'identité',
      idDocument: 'Pièce d\'identité (image ou PDF)',
      uploadFile: 'Télécharger (image / PDF)',
      scanFile: 'Scanner avec la caméra',
      selfieVideo: 'Vidéo selfie en direct',
      selfieHint: 'Filmez-vous de face quelques secondes. Cette vidéo permet de comparer votre visage avec votre pièce d’identité.',
      consent: 'J\'accepte que ma pièce d\'identité et ma vidéo soient traitées par HugoQuiz à des fins de vérification d\'identité, conformément aux conditions d\'utilisation et à la politique de confidentialité.',
      submit: 'Soumettre ma demande de vérification',
      submitted: 'Votre demande a été envoyée à notre équipe.',
      invalidIdFile: 'Veuillez fournir une image ou un PDF.',
      fileTooLarge: 'Fichier trop volumineux (max 30 Mo).',
      needId: 'Veuillez fournir votre pièce d\'identité.',
      needSelfie: 'Veuillez enregistrer votre vidéo selfie.',
      needConsent: 'Vous devez accepter les conditions.',
      cameraError: 'Impossible d\'accéder à la caméra. Autorisez l\'accès et réessayez.',
      enableCamera: 'Activer la caméra',
      recorded: 'Vidéo enregistrée',
      startRecording: 'Démarrer',
      stopRecording: 'Arrêter',
      retake: 'Recommencer'
    },
    contact: {
      title: 'Contact',
      intro: 'Décrivez avec précision votre besoin ou projet et nous vous répondrons dans les plus brefs délais.',
      fullName: 'Nom complet',
      phone: 'Numéro de téléphone',
      email: 'Adresse e-mail',
      emailPlaceholder: 'vous@exemple.com',
      invalidEmail: 'Veuillez saisir un e-mail valide.',
      clientType: 'Type de client',
      individual: 'Particulier',
      company: 'Entreprise',
      subject: 'Objet de la demande',
      request: 'Décrivez votre requête / le service souhaité',
      send: 'Envoyer ma demande',
      sent: 'Votre demande a bien été envoyée !',
      sentTitle: 'Demande envoyée !',
      sentDesc: 'Le prestataire a reçu votre message et vous répondra rapidement.',
      fillRequired: 'Veuillez remplir les champs obligatoires.',
      consentRequired: 'Vous devez accepter le traitement de vos données.',
      consent: 'J\'accepte que mes données soient transmises au prestataire afin qu\'il puisse répondre à ma demande.'
    },
    reviews: {
      title: 'Avis',
      rating: 'note',
      ratings: 'notes',
      customerReviews: 'Avis des clients',
      summaryDesc: 'Partagez votre expérience avec ce prestataire pour aider les autres clients.',
      writeReview: 'Donner mon avis',
      yourReview: 'Votre avis',
      yourRating: 'Votre note',
      yourName: 'Votre nom',
      yourComment: 'Votre commentaire',
      optional: 'facultatif',
      commentPlaceholder: 'Décrivez votre expérience…',
      commentModerated: 'Les commentaires sont validés par un administrateur avant publication.',
      submit: 'Publier mon avis',
      submitted: 'Merci pour votre note !',
      submittedPending: 'Merci ! Votre commentaire sera publié après validation.',
      pendingNote: 'Votre commentaire est en attente de validation par un administrateur.',
      alreadyReviewed: 'Vous avez déjà évalué ce service.',
      noReviews: 'Aucun avis pour le moment. Soyez le premier à donner votre avis !',
      anonymous: 'Anonyme',
      pickRating: 'Veuillez attribuer une note.',
      enterName: 'Veuillez indiquer votre nom.'
    },
    messages: {
      title: 'Messages reçus',
      subtitle: 'Les demandes envoyées via vos services apparaissent ici.',
      empty: 'Aucun message pour le moment'
    }
  }
}
